import React, { useCallback, useEffect, useState } from 'react';
import { ShoppingCart,Calendar, ChevronRight, Phone, MapPin, Star,CreditCard,
  HandCoins, Plus, Minus, Truck, Store, CheckCircle, X, Check, Clock, Users, Heart, Menu, Wallet, Instagram, MessageCircle } from 'lucide-react';
import RazorpayPayment from './Components/Payment/RazorpayPayment';
import homeimg from "./Components/Assets/homeimg.gif"
import axios from 'axios';
import logo from './Components/Assets/logo.png'
import { format } from 'date-fns';

// Main App Component
const App = () => {
  const [currentView, setCurrentView] = useState('home');
  const [cart, setCart] = useState([]);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [user, setUser] = useState(null);

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 to-red-50">
      <Header
        cart={cart}
        setIsCartOpen={setIsCartOpen}
        currentView={currentView}
        setCurrentView={setCurrentView}
        user={user}
        setUser={setUser}
      />

      {currentView === 'home' && <HomePage setCurrentView={setCurrentView} />}
      {currentView === 'menu' && <MenuPage cart={cart} setCart={setCart} />}
      {currentView === 'about' && <AboutPage />}
      {currentView === 'contact' && <ContactPage />}
      {currentView === '⁠Dine-in' && <DineInBooking />}
      <Cart
        isOpen={isCartOpen}
        setIsOpen={setIsCartOpen}
        cart={cart}
        setCart={setCart}
        setCurrentView={setCurrentView}
      />

      <Footer setCurrentView={setCurrentView} />
    </div>
  );
};


const Header = ({ cart, setIsCartOpen, currentView, setCurrentView, user, setUser }) => {
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const cartItemsCount = cart.reduce((total, item) => total + item.quantity, 0);

  return (
    <>
      <header className="fixed top-0 w-full bg-lightCream/95 backdrop-blur-lg shadow-md z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">

            {/* Logo */}
            <div
              className="flex items-center space-x-2 cursor-pointer"
              onClick={() => setCurrentView('home')}
            >
              <div className="relative">
                <div className="absolute inset-0 bg-primary/30 rounded-full blur-xl animate-pulse scale-150 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                <div className="relative w-14 h-14 md:w-16 md:h-16 bg-gradient-to-br from-primary via-redAccent to-yellowBright rounded-full p-1 shadow-2xl transform group-hover:scale-110 group-hover:rotate-6 transition-all duration-300">
                  <img
                    src={logo}
                    alt="Brand logo"
                    className="w-full h-full object-contain rounded-full bg-lightCream/90 p-1"
                  />
                </div>
              </div>
            </div>
            {/* <div className="absolute -bottom-8 -left-8 md:-bottom-12 md:-right-12 text-6xl md:text-8xl animate-bounce-slow opacity-30 pointer-events-none" style={{ animationDelay: '0.5s' }}>
                🍕
                </div> */}
            <div className="absolute -left-6 md:-left-10 top-1/2 transform -translate-y-1/2 pointer-events-none z-0">
              <div className="relative">
                <div className="absolute inset-0 bg-orange-400 rounded-full blur-2xl opacity-40 animate-pulse"></div>
                <div
                  className="text-5xl md:text-7xl animate-float-rotate"
                  style={{ animation: 'floatRotate 6s ease-in-out infinite' }}
                >
                  🍕
                </div>
              </div>
            </div>

            {/* === ANIMATED BURGER (Right) === */}
            {/* <div className="absolute -right-6 md:-right-10 top-1/2 transform -translate-y-1/2 pointer-events-none z-0">
              <div className="relative">
                <div className="absolute inset-0 bg-amber-500 rounded-full blur-2xl opacity-40 animate-pulse" style={{ animationDelay: '0.8s' }}></div>
                <div
                  className="text-5xl md:text-7xl animate-float-rotate-reverse"
                  style={{ animation: 'floatRotateReverse 5s ease-in-out infinite 0.5s' }}
                >
                  🍔
                </div>
              </div>
            </div> */}
            {/* Navigation - Desktop */}
            <nav className="hidden md:flex space-x-6">
              {['home', 'menu', 'about', 'contact',"⁠Dine-in"].map((item) => (
                <button
                  key={item}
                  onClick={() => setCurrentView(item)}
                  className={`capitalize font-medium px-4 py-2 rounded-full transition-all duration-300 ${currentView === item
                    ? 'bg-primary text-lightCream shadow-lg'
                    : 'text-darkBlue hover:text-primary hover:bg-yellowBright/20'
                    }`}
                >
                  {item}
                </button>
              ))}
            </nav>

            {/* User & Cart */}
            <div className="flex items-center space-x-4">
              {user ? (
                <div className="hidden md:flex items-center space-x-2">
                  <span className="text-darkBlue text-sm">Hello, {user.name}</span>
                  <button
                    onClick={() => setUser(null)}
                    className="text-redAccent hover:text-[#b21014] text-sm"
                  >
                    Logout
                  </button>
                </div>
              ) : (
                <button
                  onClick={() => setIsLoginOpen(true)}
                  className="hidden md:block bg-primary text-lightCream px-4 py-2 rounded-full hover:bg-secondary transition-colors"
                >
                  Login
                </button>
              )}

              {/* Cart */}
              <button
                onClick={() => setIsCartOpen(true)}
                className="relative bg-gradient-to-r from-primary to-redAccent text-lightCream p-3 rounded-full hover:shadow-lg transition-all duration-300 transform hover:scale-105"
              >
                <ShoppingCart className="w-5 h-5" />
                {cartItemsCount > 0 && (
                  <span className="absolute -top-2 -right-2 bg-yellowBright text-darkBlue text-xs font-bold rounded-full w-6 h-6 flex items-center justify-center animate-pulse">
                    {cartItemsCount}
                  </span>
                )}
              </button>

              {/* Mobile Menu Toggle */}
              <button
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                className="md:hidden text-primary"
              >
                {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
              </button>
            </div>

          </div>

          {/* Mobile Navigation Menu */}
          {isMobileMenuOpen && (
            <nav className="md:hidden flex flex-col space-y-4 pb-4 border-t border-gray-200 mt-4">
              {['home', 'menu', 'about', 'contact',"⁠Dine-in"].map((item) => (
                <button
                  key={item}
                  onClick={() => {
                    setCurrentView(item);
                    setIsMobileMenuOpen(false);
                  }}
                  className={`capitalize font-medium px-4 py-2 rounded-full transition-all duration-300 text-left ${currentView === item
                    ? 'bg-primary text-lightCream shadow-lg'
                    : 'text-darkBlue hover:text-primary hover:bg-yellowBright/20'
                    }`}
                >
                  {item}
                </button>
              ))}
              {user ? (
                <div className="flex flex-col space-y-2 px-4">
                  <span className="text-darkBlue text-sm">Hello, {user.name}</span>
                  <button
                    onClick={() => {
                      setUser(null);
                      setIsMobileMenuOpen(false);
                    }}
                    className="text-redAccent hover:text-[#b21014] text-sm text-left"
                  >
                    Logout
                  </button>
                </div>
              ) : (
                <button
                  onClick={() => {
                    setIsLoginOpen(true);
                    setIsMobileMenuOpen(false);
                  }}
                  className="bg-primary text-lightCream px-4 py-2 rounded-full hover:bg-secondary transition-colors mx-4"
                >
                  Login
                </button>
              )}
            </nav>
          )}
        </div>
      </header>

      {/* Login Modal */}
      <LoginModal
        isOpen={isLoginOpen}
        setIsOpen={setIsLoginOpen}
        setUser={setUser}
      />
    </>
  );
};


// Login/Phone Verification Modal
const LoginModal = ({ isOpen, setIsOpen, setUser }) => {
  const [step, setStep] = useState('phone'); // 'phone' or 'otp'
  const [phone, setPhone] = useState('');
  const [otp, setOtp] = useState('');
  const [name, setName] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const sendOTP = async () => {
    if (phone.length !== 10) {
      setError('Please enter a valid 10-digit phone number');
      return;
    }

    setIsLoading(true);
    setError('');

    // Simulate API call
    setTimeout(() => {
      setIsLoading(false);
      setStep('otp');
    }, 2000);
  };

  const verifyOTP = async () => {
    if (otp !== '1234') {
      setError('Invalid OTP. Use 1234 for demo');
      return;
    }

    if (!name.trim()) {
      setError('Please enter your name');
      return;
    }

    setIsLoading(true);

    setTimeout(() => {
      setUser({ phone, name: name.trim() });
      setIsOpen(false);
      setStep('phone');
      setPhone('');
      setOtp('');
      setName('');
      setError('');
      setIsLoading(false);
    }, 1500);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-[60] p-4">
      <div className="bg-lightCream rounded-2xl p-6 w-full max-w-md shadow-2xl">
        {/* Header */}
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold text-darkBlue">
            {step === 'phone' ? 'Login with Phone' : 'Verify OTP'}
          </h2>
          <button
            onClick={() => setIsOpen(false)}
            className="text-darkBlue/50 hover:text-darkBlue transition-colors"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        {/* Error */}
        {error && (
          <div className="bg-redAccent/20 border border-redAccent text-redAccent px-4 py-3 rounded-lg mb-4">
            {error}
          </div>
        )}

        {/* Phone Step */}
        {step === 'phone' ? (
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-darkBlue mb-2">
                Phone Number
              </label>
              <div className="flex">
                <span className="inline-flex items-center px-3 rounded-l-lg border border-r-0 border-darkBlue/30 bg-lightCream text-darkBlue/70">
                  +91
                </span>
                <input
                  type="tel"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value.replace(/\D/g, '').slice(0, 10))}
                  placeholder="Enter 10-digit number"
                  className="flex-1 px-4 py-3 border border-darkBlue/30 rounded-r-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none"
                />
              </div>
            </div>

            <button
              onClick={sendOTP}
              disabled={isLoading || phone.length !== 10}
              className="w-full bg-primary text-lightCream py-3 rounded-lg hover:bg-secondary disabled:opacity-50 disabled:cursor-not-allowed font-medium transition-colors"
            >
              {isLoading ? 'Sending OTP...' : 'Send OTP'}
            </button>
          </div>
        ) : (
          <div className="space-y-4">
            {/* OTP Input */}
            <div>
              <label className="block text-sm font-medium text-darkBlue mb-2">
                Enter OTP sent to +91 {phone}
              </label>
              <input
                type="text"
                value={otp}
                onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 4))}
                placeholder="Enter 4-digit OTP (use 1234)"
                className="w-full px-4 py-3 border border-darkBlue/30 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none text-center text-lg tracking-widest"
              />
            </div>

            {/* Name Input */}
            <div>
              <label className="block text-sm font-medium text-darkBlue mb-2">
                Your Name
              </label>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Enter your full name"
                className="w-full px-4 py-3 border border-darkBlue/30 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none"
              />
            </div>

            <button
              onClick={verifyOTP}
              disabled={isLoading || otp.length !== 4 || !name.trim()}
              className="w-full bg-primary text-lightCream py-3 rounded-lg hover:bg-secondary disabled:opacity-50 disabled:cursor-not-allowed font-medium transition-colors"
            >
              {isLoading ? 'Verifying...' : 'Verify & Login'}
            </button>

            <button
              onClick={() => setStep('phone')}
              className="w-full text-primary hover:text-secondary font-medium"
            >
              ← Change Phone Number
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

// Home Page Component
// const HomePage = ({ setCurrentView }) => {

//   const emojis = [
//     { icon: "🍕", name: "Pizza" },
//     { icon: "🍔", name: "Burger" },
//     { icon: "🍝", name: "Pasta" },
//     { icon: "🥪", name: "Sandwich" },
//     { icon: "🥟", name: "Momos" },
//     { icon: "🍗", name: "Wings" },
//   ];

//   const createEmojiRain = (emoji) => {
//     for (let i = 0; i < 30; i++) {
//       const span = document.createElement("span");
//       span.innerText = emoji;
//       span.style.position = "fixed";
//       span.style.left = Math.random() * window.innerWidth + "px";
//       span.style.top = "-30px";
//       span.style.fontSize = `${Math.random() * 20 + 20}px`;
//       span.style.pointerEvents = "none";
//       span.style.animation = `fall 2s linear`;
//       span.style.zIndex = 50;
//       document.body.appendChild(span);
//       setTimeout(() => span.remove(), 2000);
//     }
//   };
//   return (
//     <div className="pt-24">
//       {/* Hero Section */}
//       {/* <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
//         <div className="absolute inset-0 bg-gradient-to-br from-orange-400 via-red-500 to-pink-500 opacity-90"></div>
//         <div className="absolute inset-0 bg-black/20"></div>

//         <div className="relative z-10 text-center text-white px-4 max-w-4xl mx-auto">
//           <div className="mb-8 animate-bounce">
//             <div className="text-8xl">🍕</div>
//           </div>

//           <h1 className="text-6xl md:text-8xl font-bold mb-6 animate-pulse">
//             OyePai
//           </h1>

//           <p className="text-2xl md:text-3xl mb-4 font-light">
//             Eat Love Repeat
//           </p>

//           <p className="text-xl mb-8 opacity-90">
//             Perfect place to hangout and chill 🥰
//           </p>

//           <div className="flex flex-wrap justify-center gap-4 mb-12 text-lg">
//             <span className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full">🍕 Pizza</span>
//             <span className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full">🍔 Burger</span>
//             <span className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full">🍝 Pasta</span>
//             <span className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full">🥪 Sandwich</span>
//             <span className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full">🥟 Momos</span>
//             <span className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full">🍗 Wings</span>
//           </div>

//           <button
//             onClick={() => setCurrentView('menu')}
//             className="bg-white text-orange-500 text-xl font-bold py-4 px-8 rounded-full hover:bg-orange-50 transform hover:scale-105 transition-all duration-300 shadow-2xl"
//           >
//             Order Now
//           </button>
//         </div>


//         <div className="absolute top-20 left-10 text-4xl animate-bounce" style={{ animationDelay: '0s' }}>🍕</div>
//         <div className="absolute top-40 right-20 text-3xl animate-bounce" style={{ animationDelay: '1s' }}>🍔</div>
//         <div className="absolute bottom-40 left-20 text-3xl animate-bounce" style={{ animationDelay: '2s' }}>🍝</div>
//         <div className="absolute bottom-20 right-10 text-4xl animate-bounce" style={{ animationDelay: '1.5s' }}>🥟</div>
//       </section> */}
//       {/* Hero Section */}
//       <section
//         className="relative min-h-screen flex items-center justify-center overflow-hidden bg-cover bg-center bg-no-repeat"
//         style={{
//           backgroundImage: `url(${homeimg})`,
//         }}
//       >
//         {/* Dark overlay */}
//         <div className="absolute inset-0 bg-black/20"></div>

//         <div className="relative z-10 text-center text-white px-4 max-w-4xl mx-auto">
//           <div className="mb-8 animate-bounce">
//             <div className="text-8xl">🍕</div>
//           </div>

//           {/* <h1 className="text-6xl md:text-8xl font-bold mb-6 animate-pulse">
//             OyePai
//           </h1>

//           <p className="text-2xl md:text-3xl mb-4 font-light">
//             Eat Love Repeat
//           </p>

//           <p className="text-xl mb-8 opacity-90">
//             Perfect place to hangout and chill 🥰
//           </p> */}
//           <div className="flex flex-wrap justify-center gap-4 mb-12 text-lg">
//             {emojis.map((item, index) => (
//               <span
//                 key={index}
//                 onClick={() => createEmojiRain(item.icon)}
//                 className="bg-white/5 backdrop-blur-md px-4 py-2 rounded-full border border-[#ffb400] text-white shadow-[0_0_10px_#ffb400] hover:shadow-[0_0_20px_#ffb400] transition-all duration-300 transform hover:scale-110 hover:animate-[wiggle_0.5s_ease-in-out] cursor-pointer"
//                 style={{ borderRadius: "9999px" }}
//               >
//                 {item.icon} {item.name}
//               </span>
//             ))}
//           </div>

//           <div className="flex flex-wrap justify-center gap-4 mb-12 text-lg">
//             <span className="bg-white/5 backdrop-blur-md px-4 py-2 rounded-full border border-[#ffb400] text-white shadow-[0_0_10px_#ffb400] hover:shadow-[0_0_20px_#ffb400] transition-all duration-300 transform hover:scale-110 hover:animate-[wiggle_0.5s_ease-in-out]" style={{ borderRadius: '9999px' }}>🍕 Pizza</span>
//             <span className="bg-white/5 backdrop-blur-md px-4 py-2 rounded-full border border-[#ffb400] text-white shadow-[0_0_10px_#ffb400] hover:shadow-[0_0_20px_#ffb400] transition-all duration-300 transform hover:scale-110 hover:animate-[wiggle_0.5s_ease-in-out]" style={{ borderRadius: '9999px' }}>🍔 Burger</span>
//             <span className="bg-white/5 backdrop-blur-md px-4 py-2 rounded-full border border-[#ffb400] text-white shadow-[0_0_10px_#ffb400] hover:shadow-[0_0_20px_#ffb400] transition-all duration-300 transform hover:scale-110 hover:animate-[wiggle_0.5s_ease-in-out]" style={{ borderRadius: '9999px' }}>🍝 Pasta</span>
//             <span className="bg-white/5 backdrop-blur-md px-4 py-2 rounded-full border border-[#ffb400] text-white shadow-[0_0_10px_#ffb400] hover:shadow-[0_0_20px_#ffb400] transition-all duration-300 transform hover:scale-110 hover:animate-[wiggle_0.5s_ease-in-out]" style={{ borderRadius: '9999px' }}>🥪 Sandwich</span>
//             <span className="bg-white/5 backdrop-blur-md px-4 py-2 rounded-full border border-[#ffb400] text-white shadow-[0_0_10px_#ffb400] hover:shadow-[0_0_20px_#ffb400] transition-all duration-300 transform hover:scale-110 hover:animate-[wiggle_0.5s_ease-in-out]" style={{ borderRadius: '9999px' }}>🥟 Momos</span>
//             <span className="bg-white/5 backdrop-blur-md px-4 py-2 rounded-full border border-[#ffb400] text-white shadow-[0_0_10px_#ffb400] hover:shadow-[0_0_20px_#ffb400] transition-all duration-300 transform hover:scale-110 hover:animate-[wiggle_0.5s_ease-in-out]" style={{ borderRadius: '9999px' }}>🍗 Wings</span>


//           </div>

//           <button
//             onClick={() => setCurrentView('menu')}
//             className="bg-white text-orange-500 text-xl font-bold py-4 px-8 rounded-full hover:bg-orange-50 transform hover:scale-105 transition-all duration-300 shadow-2xl"
//           >
//             Order Now
//           </button>
//         </div>

//         {/* Floating food emojis */}
//         <div className="absolute top-20 left-10 text-4xl animate-bounce" style={{ animationDelay: '0s' }}>🍕</div>
//         <div className="absolute top-40 right-20 text-3xl animate-bounce" style={{ animationDelay: '1s' }}>🍔</div>
//         <div className="absolute bottom-40 left-20 text-3xl animate-bounce" style={{ animationDelay: '2s' }}>🍝</div>
//         <div className="absolute bottom-20 right-10 text-4xl animate-bounce" style={{ animationDelay: '1.5s' }}>🥟</div>
//       </section>


//       {/* Features Section */}
//       <section className="py-20 bg-white">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="text-center mb-16">
//             <h2 className="text-4xl font-bold text-gray-800 mb-4">Why Everyone Loves OyEPAI?</h2>
//             <p className="text-xl text-gray-600">Experience the best food delivery in Chennai</p>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
//             <div className="text-center p-8 rounded-2xl bg-gradient-to-br from-orange-50 to-red-50 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
//               <Clock className="w-16 h-16 text-orange-500 mx-auto mb-4" />
//               <h3 className="text-2xl font-bold mb-4 text-gray-800">Fast Delivery</h3>
//               <p className="text-gray-600">Quick and hot delivery to your doorstep in 30 minutes or less</p>
//             </div>

//             <div className="text-center p-8 rounded-2xl bg-gradient-to-br from-orange-50 to-red-50 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
//               <Star className="w-16 h-16 text-orange-500 mx-auto mb-4" />
//               <h3 className="text-2xl font-bold mb-4 text-gray-800">Quality Food</h3>
//               <p className="text-gray-600">Crafted with Fresh Ingredients and authentic recipes for unbeatable flavour</p>
//             </div>

//             <div className="text-center p-8 rounded-2xl bg-gradient-to-br from-orange-50 to-red-50 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
//               <Users className="w-16 h-16 text-orange-500 mx-auto mb-4" />
//               <h3 className="text-2xl font-bold mb-4 text-gray-800">Great Hangout</h3>
//               <p className="text-gray-600">A crazy spot to Chill, Laugh & Share great food with great company</p>
//             </div>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

const HomePage = ({ setCurrentView }) => {
  const emojis = [
    { icon: "🍕", name: "Pizza" },
    { icon: "🍔", name: "Burger" },
    { icon: "🍝", name: "Pasta" },
    { icon: "🥪", name: "Sandwich" },
    { icon: "🥟", name: "Momos" },
    { icon: "🍗", name: "Wings" },
  ];

  /** --------------------------------------------------------------
   *  Create a realistic emoji rain
   *  -------------------------------------------------------------- */
  const createEmojiRain = (emoji: string) => {
    const count = 30;                     // how many drops
    const duration = 2.5;                 // base fall time (seconds)
    const maxDelay = 0.8;                 // spread start times

    for (let i = 0; i < count; i++) {
      const span = document.createElement("span");

      // ----- content ------------------------------------------------
      span.textContent = emoji;

      // ----- position -----------------------------------------------
      const left = Math.random() * window.innerWidth;
      span.style.position = "fixed";
      span.style.left = `${left}px`;
      span.style.top = `-50px`;                     // start above viewport

      // ----- size ---------------------------------------------------
      const size = Math.random() * 20 + 25;        // 25-45px
      span.style.fontSize = `${size}px`;

      // ----- animation ----------------------------------------------
      const fallTime = duration + Math.random() * 0.5;   // 2.5-3s
      const delay = Math.random() * maxDelay;           // 0-0.8s
      const drift = (Math.random() - 0.5) * 120;        // -60…+60px wind

      span.style.animation = `rainFall ${fallTime}s linear ${delay}s forwards`;
      span.style.setProperty("--drift", `${drift}px`);

      // ----- visual polish -------------------------------------------
      span.style.pointerEvents = "none";
      span.style.userSelect = "none";
      span.style.zIndex = "50";
      span.style.transform = `rotate(${Math.random() * 360}deg)`;

      document.body.appendChild(span);

      // ----- cleanup -------------------------------------------------
      setTimeout(() => span.remove(), (fallTime + delay) * 1000 + 100);
    }
  };

  return (
    <div className="pt-24">
      {/* ==============================================================
           HERO SECTION
      ============================================================== */}
      <section
        className="relative min-h-screen flex items-center justify-center overflow-hidden bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${homeimg})` }}
      >
        <div className="absolute inset-0 bg-black/20"></div>

        <div className="relative z-10 text-center text-white px-4 max-w-4xl mx-auto">
          <div className="mb-8 animate-bounce">
            <div className="text-8xl">🍕</div>
          </div>

          {/* Food badges – click → rain */}
          <div className="flex flex-wrap justify-center gap-4 mb-12 text-lg">
            {emojis.map((item, idx) => (
              <span
                key={idx}
                onClick={() => createEmojiRain(item.icon)}
                className="bg-white/5 backdrop-blur-md px-4 py-2 rounded-full border border-[#ffb400] text-white shadow-[0_0_10px_#ffb400] hover:shadow-[0_0_20px_#ffb400] transition-all duration-300 transform hover:scale-110 hover:animate-[wiggle_0.5s_ease-in-out] cursor-pointer"
                style={{ borderRadius: "9999px" }}
              >
                {item.icon} {item.name}
              </span>
            ))}
          </div>

          <button
            onClick={() => setCurrentView("menu")}
            className="bg-primary text-lightCream text-xl font-bold py-4 px-8 rounded-full hover:bg-secondary transform hover:scale-105 transition-all duration-300 shadow-2xl"
          >
            Order Now
          </button>
        </div>

        {/* Floating decorations */}
        <div className="absolute top-20 left-10 text-4xl animate-bounce" style={{ animationDelay: "0s" }}>
          🍕
        </div>
        <div className="absolute top-40 right-20 text-3xl animate-bounce" style={{ animationDelay: "1s" }}>
          🍔
        </div>
        <div className="absolute bottom-40 left-20 text-3xl animate-bounce" style={{ animationDelay: "2s" }}>
          🍝
        </div>
        <div className="absolute bottom-20 right-10 text-4xl animate-bounce" style={{ animationDelay: "1.5s" }}>
          🥟
        </div>
      </section>

      {/* ==============================================================
           FEATURES SECTION
      ============================================================== */}
      <section className="py-20 bg-lightCream">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-orange-900 mb-4">
              Why Everyone Loves OyePai?
            </h2>
            <p className="text-xl text-orange-700">
              Experience the best food delivery in Chennai
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">

            {/* Fast Delivery */}
            <div className="text-center p-6 rounded-2xl bg-gradient-to-br from-orange-50 to-amber-50 border-2 border-orange-400 hover:border-orange-500 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 group">
              <div className="w-16 h-16 mx-auto mb-4 bg-orange-500 text-white rounded-full flex items-center justify-center shadow-md group-hover:bg-orange-600 transition-colors">
                <Clock className="w-9 h-9" />
              </div>
              <h3 className="text-xl font-bold mb-2 text-orange-900">Fast Delivery</h3>
              <p className="text-orange-700 text-sm leading-relaxed">
                Get your Food Hot & Fresh at your Doorstep in just 30mins (or) Less
              </p>
            </div>

            {/* Quality Food */}
            <div className="text-center p-6 rounded-2xl bg-gradient-to-br from-orange-50 to-amber-50 border-2 border-orange-400 hover:border-orange-500 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 group">
              <div className="w-16 h-16 mx-auto mb-4 bg-orange-500 text-white rounded-full flex items-center justify-center shadow-md group-hover:bg-orange-600 transition-colors">
                <Star className="w-9 h-9" />
              </div>
              <h3 className="text-xl font-bold mb-2 text-orange-900">Quality Food</h3>
              <p className="text-orange-700 text-sm leading-relaxed">
                Crafted with Fresh Ingredients and authentic recipes for unbeatable flavour
              </p>
            </div>

            {/* Great Hangout */}
            <div className="text-center p-6 rounded-2xl bg-gradient-to-br from-orange-50 to-amber-50 border-2 border-orange-400 hover:border-orange-500 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 group">
              <div className="w-16 h-16 mx-auto mb-4 bg-orange-500 text-white rounded-full flex items-center justify-center shadow-md group-hover:bg-orange-600 transition-colors">
                <Users className="w-9 h-9" />
              </div>
              <h3 className="text-xl font-bold mb-2 text-orange-900">Great Hangout</h3>
              <p className="text-orange-700 text-sm leading-relaxed">
                A crazy spot to Chill, Laugh & Share great food with great company
              </p>
            </div>

            {/* Affordable Price */}
            <div className="text-center p-6 rounded-2xl bg-gradient-to-br from-orange-50 to-amber-50 border-2 border-orange-400 hover:border-orange-500 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 group">
              <div className="w-16 h-16 mx-auto mb-4 bg-orange-500 text-white rounded-full flex items-center justify-center shadow-md group-hover:bg-orange-600 transition-colors">
                <Wallet className="w-9 h-9" />
              </div>
              <h3 className="text-xl font-bold mb-2 text-orange-900">Affordable Price</h3>
              <p className="text-orange-700 text-sm leading-relaxed">
                Delicious food that doesn’t burn your pocket
              </p>
            </div>

          </div>
        </div>
      </section>

      {/* ==============================================================
           KEYFRAMES – must be inside the component (or a global stylesheet)
      ============================================================== */}
      <style jsx>{`
        @keyframes rainFall {
          0% {
            transform: translateY(-100px) translateX(0) rotate(0deg);
            opacity: 1;
          }
          100% {
            transform: translateY(calc(100vh + 100px))
                       translateX(var(--drift))
                       rotate(360deg);
            opacity: 0;
          }
        }

        @keyframes wiggle {
          0%, 100% { transform: rotate(-3deg); }
          50% { transform: rotate(3deg); }
        }
      `}</style>
    </div>
  );
};

// Menu Page Component
// const MenuPage = ({ cart, setCart }) => {
//   const [selectedCategory, setSelectedCategory] = useState('Pizza');
//   const [searchTerm, setSearchTerm] = useState('');

//   // const menuItems = {
//   //   Pizza: [
//   //     { id: 1, name: 'Margherita Pizza', price: 299, image: '🍕', description: 'Classic tomato sauce, mozzarella, and fresh basil', rating: 4.5 },
//   //     { id: 2, name: 'Pepperoni Pizza', price: 399, image: '🍕', description: 'Spicy pepperoni with cheese and tomato sauce', rating: 4.7 },
//   //     { id: 3, name: 'Vegetarian Supreme', price: 449, image: '🍕', description: 'Mixed vegetables with cheese and herbs', rating: 4.3 },
//   //     { id: 4, name: 'Chicken BBQ', price: 499, image: '🍕', description: 'BBQ chicken with onions and peppers', rating: 4.8 }
//   //   ],
//   //   Burger: [
//   //     { id: 5, name: 'Classic Beef Burger', price: 249, image: '🍔', description: 'Juicy beef patty with lettuce, tomato, and cheese', rating: 4.6 },
//   //     { id: 6, name: 'Chicken Burger', price: 229, image: '🍔', description: 'Grilled chicken with mayo and vegetables', rating: 4.4 },
//   //     { id: 7, name: 'Veg Burger', price: 199, image: '🍔', description: 'Fresh veggie patty with special sauce', rating: 4.2 }
//   //   ],
//   //   Pasta: [
//   //     { id: 8, name: 'Spaghetti Carbonara', price: 329, image: '🍝', description: 'Creamy pasta with bacon and parmesan', rating: 4.7 },
//   //     { id: 9, name: 'Penne Arrabbiata', price: 289, image: '🍝', description: 'Spicy tomato sauce with herbs', rating: 4.5 }
//   //   ],
//   //   Momos: [
//   //     { id: 10, name: 'Veg Momos', price: 149, image: '🥟', description: 'Steamed dumplings with vegetables', rating: 4.3 },
//   //     { id: 11, name: 'Chicken Momos', price: 179, image: '🥟', description: 'Steamed dumplings with chicken filling', rating: 4.6 }
//   //   ]
//   // };



//   const categories = Object.keys(menuItems);
//   const filteredItems = menuItems[selectedCategory]?.filter(item =>
//     item.name.toLowerCase().includes(searchTerm.toLowerCase())
//   ) || [];

//   const addToCart = (item) => {
//     setCart(prev => {
//       const existing = prev.find(cartItem => cartItem.id === item.id);
//       if (existing) {
//         return prev.map(cartItem =>
//           cartItem.id === item.id
//             ? { ...cartItem, quantity: cartItem.quantity + 1 }
//             : cartItem
//         );
//       }
//       return [...prev, { ...item, quantity: 1 }];
//     });
//   };

//   return (
//     <div className="pt-24 min-h-screen">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
//         <div className="text-center mb-12">
//           <h1 className="text-4xl font-bold text-gray-800 mb-4">Our Delicious Menu</h1>
//           <p className="text-xl text-gray-600">Choose from our amazing selection</p>
//         </div>

//         {/* Search Bar */}
//         <div className="mb-8">
//           <input
//             type="text"
//             placeholder="Search for food..."
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             className="w-full max-w-md mx-auto block px-4 py-3 border border-gray-300 rounded-full focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none"
//           />
//         </div>

//         {/* Category Tabs */}
//         <div className="flex flex-wrap justify-center gap-4 mb-12">
//           {categories.map(category => (
//             <button
//               key={category}
//               onClick={() => setSelectedCategory(category)}
//               className={`px-6 py-3 rounded-full font-medium transition-all duration-300 ${
//                 selectedCategory === category
//                   ? 'bg-orange-500 text-white shadow-lg transform scale-105'
//                   : 'bg-white text-gray-700 hover:bg-orange-50 hover:text-orange-500'
//               }`}
//             >
//               {category}
//             </button>
//           ))}
//         </div>

//         {/* Menu Items */}
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//           {filteredItems.map(item => (
//             <div key={item.id} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2">
//               <div className="p-6">
//                 <div className="text-6xl text-center mb-4">{item.image}</div>
//                 <h3 className="text-xl font-bold text-gray-800 mb-2">{item.name}</h3>
//                 <p className="text-gray-600 mb-4">{item.description}</p>

//                 <div className="flex items-center justify-between mb-4">
//                   <div className="flex items-center">
//                     <Star className="w-5 h-5 text-yellow-400 fill-current" />
//                     <span className="ml-1 text-sm text-gray-600">{item.rating}</span>
//                   </div>
//                   <div className="text-2xl font-bold text-orange-500">₹{item.price}</div>
//                 </div>

//                 <button
//                   onClick={() => addToCart(item)}
//                   className="w-full bg-gradient-to-r from-orange-500 to-red-500 text-white py-3 rounded-full font-medium hover:shadow-lg transition-all duration-300 transform hover:scale-105"
//                 >
//                   Add to Cart
//                 </button>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };
// const MenuPage = ({ cart, setCart }) => {
//   const [selectedCategory, setSelectedCategory] = useState('Pizza');
//   const [searchTerm, setSearchTerm] = useState('');
//   const [dietFilter, setDietFilter] = useState('all'); // 'all', 'veg', 'non-veg'

//   const menuItems = {
//     Pizza: [
//       { id: 1, name: 'Margherita Pizza', price: 299, image: '🍕', description: 'Classic tomato sauce, mozzarella, and fresh basil', rating: 4.5, isVeg: true },
//       { id: 2, name: 'Pepperoni Pizza', price: 399, image: '🍕', description: 'Spicy pepperoni with cheese and tomato sauce', rating: 4.7, isVeg: false },
//       { id: 3, name: 'Vegetarian Supreme', price: 449, image: '🍕', description: 'Mixed vegetables with cheese and herbs', rating: 4.3, isVeg: true },
//       { id: 4, name: 'Chicken BBQ', price: 499, image: '🍕', description: 'BBQ chicken with onions and peppers', rating: 4.8, isVeg: false },
//       { id: 14, name: 'Paneer Tikka Pizza', price: 429, image: '🍕', description: 'Paneer tikka with capsicum and onions', rating: 4.6, isVeg: true },
//       { id: 15, name: 'Chicken Keema Pizza', price: 479, image: '🍕', description: 'Spicy minced chicken with herbs', rating: 4.7, isVeg: false }
//     ],
//     Burger: [
//       { id: 5, name: 'Classic Beef Burger', price: 249, image: '🍔', description: 'Juicy beef patty with lettuce, tomato, and cheese', rating: 4.6, isVeg: false },
//       { id: 6, name: 'Chicken Burger', price: 229, image: '🍔', description: 'Grilled chicken with mayo and vegetables', rating: 4.4, isVeg: false },
//       { id: 7, name: 'Veg Burger', price: 199, image: '🍔', description: 'Fresh veggie patty with special sauce', rating: 4.2, isVeg: true },
//       { id: 16, name: 'Paneer Burger', price: 219, image: '🍔', description: 'Crispy paneer patty with mint chutney', rating: 4.5, isVeg: true },
//       { id: 17, name: 'Fish Burger', price: 259, image: '🍔', description: 'Crispy fish fillet with tartar sauce', rating: 4.4, isVeg: false }
//     ],
//     Pasta: [
//       { id: 8, name: 'Spaghetti Carbonara', price: 329, image: '🍝', description: 'Creamy pasta with bacon and parmesan', rating: 4.7, isVeg: false },
//       { id: 9, name: 'Penne Arrabbiata', price: 289, image: '🍝', description: 'Spicy tomato sauce with herbs', rating: 4.5, isVeg: true },
//       { id: 18, name: 'Chicken Alfredo', price: 349, image: '🍝', description: 'Creamy white sauce with grilled chicken', rating: 4.8, isVeg: false },
//       { id: 19, name: 'Veg Primavera', price: 299, image: '🍝', description: 'Fresh vegetables in garlic olive oil', rating: 4.4, isVeg: true }
//     ],
//     Sandwich: [
//       { id: 20, name: 'Grilled Veg Sandwich', price: 129, image: '🥪', description: 'Grilled vegetables with cheese', rating: 4.3, isVeg: true },
//       { id: 21, name: 'Chicken Club Sandwich', price: 179, image: '🥪', description: 'Triple layer with chicken and bacon', rating: 4.6, isVeg: false },
//       { id: 22, name: 'Paneer Tikka Sandwich', price: 149, image: '🥪', description: 'Spicy paneer with mint chutney', rating: 4.5, isVeg: true },
//       { id: 23, name: 'Egg Mayo Sandwich', price: 119, image: '🥪', description: 'Boiled eggs with creamy mayo', rating: 4.2, isVeg: false }
//     ],
//     Momos: [
//       { id: 10, name: 'Veg Momos', price: 149, image: '🥟', description: 'Steamed dumplings with vegetables', rating: 4.3, isVeg: true },
//       { id: 11, name: 'Chicken Momos', price: 179, image: '🥟', description: 'Steamed dumplings with chicken filling', rating: 4.6, isVeg: false },
//       { id: 24, name: 'Paneer Momos', price: 169, image: '🥟', description: 'Steamed momos with paneer filling', rating: 4.4, isVeg: true },
//       { id: 25, name: 'Pork Momos', price: 189, image: '🥟', description: 'Traditional pork filled momos', rating: 4.7, isVeg: false }
//     ],
//     Wings: [
//       { id: 26, name: 'Buffalo Wings', price: 249, image: '🍗', description: 'Spicy buffalo sauce coated wings', rating: 4.7, isVeg: false },
//       { id: 27, name: 'BBQ Wings', price: 239, image: '🍗', description: 'Smoky BBQ glazed chicken wings', rating: 4.6, isVeg: false },
//       { id: 28, name: 'Peri Peri Wings', price: 259, image: '🍗', description: 'Fiery peri peri chicken wings', rating: 4.8, isVeg: false },
//       { id: 29, name: 'Garlic Parmesan Wings', price: 269, image: '🍗', description: 'Garlic butter with parmesan cheese', rating: 4.7, isVeg: false }
//     ]
//   };

//   const categories = Object.keys(menuItems);

//   // Apply both search and diet filters
//   const filteredItems = menuItems[selectedCategory]?.filter(item => {
//     const matchesSearch = item.name.toLowerCase().includes(searchTerm.toLowerCase());
//     const matchesDiet = dietFilter === 'all' ||
//       (dietFilter === 'veg' && item.isVeg) ||
//       (dietFilter === 'non-veg' && !item.isVeg);
//     return matchesSearch && matchesDiet;
//   }) || [];

//   // Count veg and non-veg items in current category
//   const vegCount = menuItems[selectedCategory]?.filter(item => item.isVeg).length || 0;
//   const nonVegCount = menuItems[selectedCategory]?.filter(item => !item.isVeg).length || 0;

//   const addToCart = (item) => {
//     setCart(prev => {
//       const existing = prev.find(cartItem => cartItem.id === item.id);
//       if (existing) {
//         return prev.map(cartItem =>
//           cartItem.id === item.id
//             ? { ...cartItem, quantity: cartItem.quantity + 1 }
//             : cartItem
//         );
//       }
//       return [...prev, { ...item, quantity: 1 }];
//     });
//   };

//   return (

//     <div className="pt-16 sm:pt-20 md:pt-24 min-h-screen pb-6 bg-[#fcf9e1]">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
//         {/* Header */}
//         <div className="text-center mb-8 sm:mb-12">
//           <h1 className="text-3xl sm:text-4xl font-extrabold bg-gradient-to-r from-[#ff4800] to-[#d92118] bg-clip-text text-transparent mb-4">
//             Our Delicious Menu
//           </h1>
//           <p className="text-lg sm:text-xl text-[#2e3e7b]">Choose from our amazing selection</p>
//         </div>

//         {/* Search Bar */}
//         <div className="mb-6 sm:mb-8">
//           <input
//             type="text"
//             placeholder="Search for food..."
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             className="w-full max-w-md mx-auto block px-4 py-3 sm:py-4 border border-[#2e3e7b] rounded-full focus:ring-2 focus:ring-[#ff4800] focus:border-[#ff4800] outline-none text-base sm:text-lg shadow-lg"
//           />
//         </div>

//         {/* Category Tabs */}
//         <div className="flex flex-wrap justify-center gap-2 sm:gap-4 mb-6 sm:mb-8">
//           {categories.map(category => (
//             <button
//               key={category}
//               onClick={() => {
//                 setSelectedCategory(category);
//                 setDietFilter('all');
//               }}
//               className={`px-4 sm:px-6 py-2 sm:py-3 rounded-full font-medium transition-all duration-300 transform hover:scale-105 text-sm sm:text-base ${selectedCategory === category
//                 ? 'bg-gradient-to-r from-[#ff4800] to-[#d92118] text-white shadow-xl scale-105'
//                 : 'bg-[#fcf9e1] text-[#2e3e7b] hover:bg-[#fff900] hover:text-[#ff4800] shadow-md'
//                 }`}
//             >
//               {category}
//             </button>
//           ))}
//         </div>

//         {/* Veg/Non-Veg Filter Buttons */}
//         <div className="flex flex-wrap justify-center gap-3 sm:gap-4 mb-8 sm:mb-12">
//           <button
//             onClick={() => setDietFilter('all')}
//             className={`flex items-center space-x-2 px-4 sm:px-6 py-2 sm:py-3 rounded-full font-medium transition-all duration-300 transform hover:scale-105 text-sm sm:text-base ${dietFilter === 'all'
//               ? 'bg-[#2e3e7b] text-white shadow-lg scale-105'
//               : 'bg-[#fcf9e1] text-[#2e3e7b] hover:bg-[#fff900] shadow-md border border-[#ffb400]'
//               }`}
//           >
//             <span>All Items</span>
//             <span className="bg-white text-[#2e3e7b] px-2 py-1 rounded-full text-xs font-bold">
//               {vegCount + nonVegCount}
//             </span>
//           </button>

//           <button
//             onClick={() => setDietFilter('veg')}
//             className={`flex items-center space-x-2 px-4 sm:px-6 py-2 sm:py-3 rounded-full font-medium transition-all duration-300 transform hover:scale-105 text-sm sm:text-base ${dietFilter === 'veg'
//               ? 'bg-[#fcf9e1] text-[#2e3e7b] shadow-lg scale-105 border border-[#ffb400]'
//               : 'bg-white text-[#2e3e7b] hover:bg-[#fcf9e1] hover:text-[#2e3e7b] shadow-md border-2 border-green-600'
//               }`}
//           >
//             <div className="w-4 h-4 border-2 border-green-600 rounded flex items-center justify-center">
//               <div className="w-2 h-2 bg-green-600 rounded-full"></div>
//             </div>
//             <span>Veg</span>
//             <span
//               className={`px-2 py-1 rounded-full text-xs font-bold ${dietFilter === 'veg' ? 'bg-green-600 text-white' : 'bg-green-100 text-green-800'
//                 }`}
//             >
//               {vegCount}
//             </span>
//           </button>

//           <button
//             onClick={() => setDietFilter('non-veg')}
//             className={`flex items-center space-x-2 px-4 sm:px-6 py-2 sm:py-3 rounded-full font-medium transition-all duration-300 transform hover:scale-105 text-sm sm:text-base ${dietFilter === 'non-veg'
//               ? 'bg-[#d92118] text-white shadow-lg scale-105 border border-[#ff4800]'
//               : 'bg-white text-[#d92118] hover:bg-[#ffd6d6] shadow-md border-2 border-[#d92118]'
//               }`}
//           >
//             <div className="w-4 h-4 border-2 border-[#d92118] rounded flex items-center justify-center">
//               <div className="w-2 h-2 bg-[#d92118] rounded-full"></div>
//             </div>
//             <span>Non-Veg</span>
//             <span
//               className={`px-2 py-1 rounded-full text-xs font-bold ${dietFilter === 'non-veg' ? 'bg-white text-[#d92118]' : 'bg-red-100 text-red-800'
//                 }`}
//             >
//               {nonVegCount}
//             </span>
//           </button>
//         </div>

//         {/* Menu Items */}
//         <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 sm:gap-8 lg:gap-10">
//           {filteredItems.map(item => (
//             <div
//               key={item.id}
//               className={`rounded-3xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 hover:scale-105
//               ${item.isVeg ? 'bg-[#fcf9e1]' : 'bg-[#ffd6d6]'}
//               ${item.isSpecial ? 'bg-gradient-to-br from-[#ff4800] to-[#ffb400] text-white' : ''}`}
//             >
//               <div className="p-5 sm:p-6">
//                 <div className="text-center mb-4">
//                   <div className="text-5xl sm:text-6xl mb-3 animate-bounce">{item.image}</div>
//                   <div className="flex items-center justify-center space-x-2 mb-2">
//                     <div
//                       className={`w-5 h-5 border-2 ${item.isVeg ? 'border-green-600' : 'border-[#d92118]'} rounded flex items-center justify-center`}
//                     >
//                       <div
//                         className={`w-2.5 h-2.5 rounded-full ${item.isVeg ? 'bg-green-600' : 'bg-[#d92118]'}`}
//                       ></div>
//                     </div>
//                     <span className={`text-xs font-bold ${item.isVeg ? 'text-green-600' : 'text-[#d92118]'}`}>
//                       {item.isVeg ? 'PURE VEG' : 'NON-VEG'}
//                     </span>
//                   </div>
//                 </div>

//                 <h3 className={`text-lg sm:text-xl font-bold mb-2 text-center ${item.isSpecial ? 'text-white' : 'text-[#2e3e7b]'}`}>
//                   {item.name}
//                 </h3>
//                 <p className={`mb-4 text-sm sm:text-base text-center leading-relaxed ${item.isSpecial ? 'text-white/80' : 'text-[#2e3e7b]/80'}`}>
//                   {item.description}
//                 </p>

//                 <div className="flex items-center justify-between mb-4">
//                   <div className="flex items-center space-x-1">
//                     <Star className={`w-4 h-4 ${item.isSpecial ? 'text-[#fff900]' : 'text-[#ffb400]'} fill-current`} />
//                     <span className={`text-sm font-medium ${item.isSpecial ? 'text-white' : 'text-[#2e3e7b]'}`}>
//                       {item.rating}
//                     </span>
//                   </div>
//                   <div className={`text-xl sm:text-2xl font-bold ${item.isSpecial ? 'text-white' : 'bg-gradient-to-r from-[#ff4800] to-[#ffb400] bg-clip-text text-transparent'}`}>
//                     ₹{item.price}
//                   </div>
//                 </div>

//                 <button
//                   onClick={() => addToCart(item)}
//                   className={`w-full py-3 sm:py-4 rounded-2xl font-semibold hover:shadow-xl transition-all duration-300 transform hover:scale-105 active:scale-95 ${item.isSpecial ? 'bg-white text-[#ff4800]' : 'bg-gradient-to-r from-[#ff4800] to-[#ffb400] text-white'
//                     }`}
//                 >
//                   Add to Cart
//                 </button>
//               </div>
//             </div>
//           ))}
//         </div>

//         {/* No items fallback */}
//         {filteredItems.length === 0 && (
//           <div className="text-center py-12">
//             <div className="text-6xl mb-4">😔</div>
//             <h3 className="text-xl font-semibold text-[#2e3e7b] mb-2">No items found</h3>
//             <p className="text-[#2e3e7b]/80">Try searching for something else or change your filter</p>
//           </div>
//         )}
//       </div>
//     </div>

//   );
// };









const MenuPage = ({ cart, setCart }) => {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [searchTerm, setSearchTerm] = useState('');
  const [dietFilter, setDietFilter] = useState('all');

  const [apiItems, setApiItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [showAddonsModal, setShowAddonsModal] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const [addons, setAddons] = useState([]);
  const [selectedAddons, setSelectedAddons] = useState([]);

  /* ------------------------------------------------- */
  /* 2. FETCH MENU FROM API                            */
  /* ------------------------------------------------- */
  const fetchMenu = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const { data } = await axios.get('https://oyepai.in/oyepai_api/get_items');

      if (data?.status_code !== '200' || !Array.isArray(data?.data?.items)) {
        throw new Error('Invalid API response');
      }

      const transformed = data.data.items.map(transformApiItem);
      setApiItems(transformed);
    } catch (err) {
      console.error(err);
      setError('Failed to load menu from server.');
      setApiItems([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchMenu();
  }, [fetchMenu]);

  /* ------------------------------------------------- */
  /* 3. TRANSFORM API ITEM – REAL IMAGES               */
  /* ------------------------------------------------- */
  const categoryDisplayNames = {
    pizza: 'Pizza',
    burger: 'Burger',
    pasta: 'Pasta',
    sandwich: 'Sandwich',
    wings: 'Wings',
    bread: 'Bread',
    dips: 'Dips',
    icecream: 'Ice Cream',
    brownie: 'Brownie',
    mojito: 'Mojito',
    platter: 'Platter',
    quickbites: 'Quick Bites',
    strips: 'Strips',
    popcorn: 'Popcorn',
    rice: 'Rice',
  };

  /* ------------------------------------------------- */
  /* 3. IMAGE MAP – ALL URLs ARE 100% WORKING          */
  /* ------------------------------------------------- */
  const imageUrlMap = {
    pizza: 'https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?auto=format&fit=crop&w=400&q=80',
    burger: 'https://images.unsplash.com/photo-1568901346375-23c9450c58cd?auto=format&fit=crop&w=400&q=80',
    pasta: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQNRNOtoNgNovKYEd2gYsEjkJaBurUwzyv01Q&s',
    sandwich: 'https://images.unsplash.com/photo-1528735602780-2552fd46c7af?auto=format&fit=crop&w=400&q=80',
    wings: 'https://hips.hearstapps.com/hmg-prod/images/fried-chicken-wings-index-65c103e1356ec.jpg?crop=0.6664530599166933xw:1xh;center,top&resize=1200:*',
    bread: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTZUlql58ckau2_S-D934n0WyuA6mx__9VHqA&s',
    icecream: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSzYD3fzBdT3VpyUzJp0gBJMdH3-pco5VZ7Qg&s',
    brownie: 'https://images.unsplash.com/photo-1606313564200-e75d5e30476c?auto=format&fit=crop&w=400&q=80',
    dips: 'https://i.ndtvimg.com/i/2017-02/dip_620x350_51487334712.jpg',
    mojito: 'https://assets.malibudrinks.com/wp-content/uploads/2024/02/Malibu-Mojito-16x9-2-scaled.jpg?tr=q-80,w-2560',
    platter: 'https://thecharcuterieco.in/cdn/shop/files/TCC-19-Copy_1200x1200.jpg?v=1684998671',
    quickbites: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTHT89Pr9KLBZOSKb_o-ljhqHlicI7qKHVq7g&s',
    strips: 'https://i.ytimg.com/vi/weiwMzXee8I/hq720.jpg?sqp=-oaymwEhCK4FEIIDSFryq4qpAxMIARUAAAAAGAElAADIQj0AgKJD&rs=AOn4CLAWjVxsaDQ8EZWGepNG9-HCpmv7Sg',
    popcorn: 'https://www.indianhealthyrecipes.com/wp-content/uploads/2022/06/popcorn-chicken-recipe-500x375.jpg',
    rice: 'https://images.unsplash.com/photo-1512058564366-18510be2db19?auto=format&fit=crop&w=400&q=80',
  };

  /* ------------------------------------------------- */
  /* FALLBACK – generic plate if category not found    */
  /* ------------------------------------------------- */
  const FALLBACK_IMAGE =
    'https://images.unsplash.com/photo-1506089676996-3d653b5c6c7e?auto=format&fit=crop&w=400&q=80';

  const defaultDescriptions = {
    sandwich: 'Delicious sandwich with fresh ingredients',
    burger: 'Juicy burger packed with flavor',
    pizza: 'Crispy pizza with premium toppings',
    pasta: 'Al dente pasta with rich sauce',
    wings: 'Crispy wings with bold flavors',
  };

  const transformApiItem = (apiItem) => {
    const catKey = apiItem.category.toLowerCase();
    const displayCategory =
      categoryDisplayNames[catKey] ||
      apiItem.category.charAt(0).toUpperCase() + apiItem.category.slice(1);

    return {
      id: apiItem.id,
      name: apiItem.item_name,
      price: apiItem.final_price,
      image: imageUrlMap[catKey] || 'https://oyepai.in/static/media/homeimg.35b0e4434fb6bf516269.gif',
      description:
        apiItem.item_description ||
        defaultDescriptions[catKey] ||
        'Delicious item made with fresh ingredients',
      rating: 4.5,
      isVeg: apiItem.category_type === 'v',
      size: apiItem.item_size || '',
      isAvailable: apiItem.is_available,
      category: displayCategory,
    };
  };

  /* ------------------------------------------------- */
  /* 4. BUILD CATEGORIES FROM API ONLY                 */
  /* ------------------------------------------------- */
  const allItems = apiItems;
  const categories = [
    'All',
    ...Array.from(new Set(apiItems.map((i) => i.category))).sort(),
  ];

  /* ------------------------------------------------- */
  /* 5. FILTER LOGIC                                   */
  /* ------------------------------------------------- */
  const getFilteredItems = () => {
    const itemsToShow =
      selectedCategory === 'All'
        ? allItems
        : apiItems.filter((i) => i.category === selectedCategory);

    return itemsToShow.filter((item) => {
      if (!item.isAvailable) return false;
      const matchesSearch = item.name.toLowerCase().includes(searchTerm.toLowerCase());
      const matchesDiet =
        dietFilter === 'all' ||
        (dietFilter === 'veg' && item.isVeg) ||
        (dietFilter === 'non-veg' && !item.isVeg);
      return matchesSearch && matchesDiet;
    });
  };

  const filteredItems = getFilteredItems();
  const vegCount = filteredItems.filter((i) => i.isVeg).length;
  const nonVegCount = filteredItems.filter((i) => !i.isVeg).length;

  /* ------------------------------------------------- */
  /* 6. CART HELPERS – MERGE SAME ITEM + SAME ADDONS   */
  /* ------------------------------------------------- */
  const getItemKey = (item, addonsList = []) => {
    const sorted = addonsList.map((a) => a.id).sort().join('-');
    return `${item.id}-${sorted}`;
  };

  const addToCart = (item, addonsList = []) => {
    const key = getItemKey(item, addonsList);
    const totalPrice = item.price + addonsList.reduce((s, a) => s + a.final_price, 0);

    const cartItem = {
      ...item,
      quantity: 1,
      addons: addonsList.map((a) => ({
        id: a.id,
        name: a.item_name,
        price: a.final_price,
      })),
      totalPrice,
      _key: key, // internal key for merging
    };

    setCart((prev) => {
      const existingIdx = prev.findIndex((c) => c._key === key);
      if (existingIdx > -1) {
        return prev.map((c, i) =>
          i === existingIdx ? { ...c, quantity: c.quantity + 1 } : c
        );
      }
      return [...prev, cartItem];
    });
  };

  const getQty = (id) => {
    const item = cart.find((c) => c.id === id);
    return item ? item.quantity : 0;
  };

  const removeOne = (id) => {
    setCart((prev) => {
      const existing = prev.find((c) => c.id === id);
      if (!existing) return prev;
      if (existing.quantity === 1) {
        return prev.filter((c) => c.id !== id);
      }
      return prev.map((c) =>
        c.id === id ? { ...c, quantity: c.quantity - 1 } : c
      );
    });
  };

  /* ------------------------------------------------- */
  /* 7. HANDLE ADD CLICK → FETCH ADDONS                */
  /* ------------------------------------------------- */
  const handleAddClick = async (item) => {
    if (!item.isAvailable) return;

    const categoryKey =
      Object.keys(categoryDisplayNames).find(
        (key) => categoryDisplayNames[key] === item.category
      ) || item.category.toLowerCase();

    try {
      const response = await axios.post('https://oyepai.in/oyepai_api/get_addons', {
        category: categoryKey,
      });

      const items = response.data?.data?.items || [];
      if (response.data?.status_code === '200' && Array.isArray(items) && items.length > 0) {
        setCurrentItem(item);
        setAddons(items);
        setSelectedAddons([]);
        setShowAddonsModal(true);
      } else {
        addToCart(item);
      }
    } catch (err) {
      console.error('Addons API failed:', err);
      addToCart(item);
    }
  };

  const confirmAddWithAddons = () => {
    if (!currentItem) return;
    addToCart(currentItem, selectedAddons);
    setShowAddonsModal(false);
    setCurrentItem(null);
    setAddons([]);
    setSelectedAddons([]);
  };

  /* ------------------------------------------------- */
  /* 8. LOADING & ERROR UI                             */
  /* ------------------------------------------------- */
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-[#fcf9e1]">
        <div className="text-2xl font-semibold text-[#2e3e7b]">Loading menu…</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-[#fcf9e1] p-4">
        <div className="bg-white/90 rounded-2xl p-6 shadow-lg max-w-md text-center">
          <p className="text-red-600 mb-2">{error}</p>
          <p className="text-sm text-gray-600">
            Please check your connection or try again later.
          </p>
        </div>
      </div>
    );
  }

  /* ------------------------------------------------- */
  /* 9. MAIN RENDER                                    */
  /* ------------------------------------------------- */
  return (
    <>
      <div
        className="pt-16 sm:pt-20 md:pt-24 min-h-screen pb-6 bg-[#fcf9e1] bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://images.unsplash.com/photo-1604382354936-07c5d9983bd3?ixlib=rb-4.0.3&auto=format&fit=crop&w=1740&q=80')`,
          backgroundBlendMode: 'overlay',
          backgroundColor: 'rgba(252, 249, 225, 0.85)',
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
          {/* Header */}
          <div className="text-center mb-8 sm:mb-12">
            <h1 className="text-3xl sm:text-4xl font-extrabold bg-gradient-to-r from-[#ff4800] to-[#d92118] bg-clip-text text-transparent mb-4">
              Our Delicious Menu
            </h1>
            <p className="text-lg sm:text-xl text-[#2e3e7b]">
              Choose from our amazing selection
            </p>
          </div>

          {/* Search */}
          <div className="mb-6 sm:mb-8">
            <input
              type="text"
              placeholder="Search for food..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full max-w-md mx-auto block px-4 py-3 sm:py-4 border border-[#2e3e7b] rounded-full focus:ring-2 focus:ring-[#ff4800] focus:border-[#ff4800] outline-none text-base sm:text-lg shadow-lg bg-white/90 backdrop-blur-sm"
            />
          </div>

          {/* Category Tabs */}
          <div className="flex flex-wrap justify-center gap-2 sm:gap-4 mb-6 sm:mb-8">
            {categories.map((cat) => (
              <button
                key={cat}
                onClick={() => {
                  setSelectedCategory(cat);
                  setDietFilter('all');
                }}
                className={`px-4 sm:px-6 py-2 sm:py-3 rounded-full font-medium transition-all duration-300 transform hover:scale-105 text-sm sm:text-base ${selectedCategory === cat
                  ? 'bg-gradient-to-r from-[#ff4800] to-[#d92118] text-white shadow-xl scale-105'
                  : 'bg-white/90 text-[#2e3e7b] hover:bg-[#fff900] hover:text-[#ff4800] shadow-md backdrop-blur-sm'
                  }`}
              >
                {cat}
              </button>
            ))}
          </div>

          {/* Diet Filters */}
          <div className="flex flex-wrap justify-center gap-3 sm:gap-4 mb-8 sm:mb-12">
            <button
              onClick={() => setDietFilter('all')}
              className={`flex items-center space-x-2 px-4 sm:px-6 py-2 sm:py-3 rounded-full font-medium transition-all duration-300 transform hover:scale-105 text-sm sm:text-base ${dietFilter === 'all'
                ? 'bg-[#2e3e7b] text-white shadow-lg scale-105'
                : 'bg-white/90 text-[#2e3e7b] hover:bg-[#fff900] shadow-md border border-[#ffb400] backdrop-blur-sm'
                }`}
            >
              <span>All Items</span>
              <span className="bg-white text-[#2e3e7b] px-2 py-1 rounded-full text-xs font-bold">
                {vegCount + nonVegCount}
              </span>
            </button>

            <button
              onClick={() => setDietFilter('veg')}
              className={`flex items-center space-x-2 px-4 sm:px-6 py-2 sm:py-3 rounded-full font-medium transition-all duration-300 transform hover:scale-105 text-sm sm:text-base ${dietFilter === 'veg'
                ? 'bg-[#fcf9e1] text-[#2e3e7b] shadow-lg scale-105 border border-[#ffb400]'
                : 'bg-white/90 text-[#2e3e7b] hover:bg-[#fcf9e1] hover:text-[#2e3e7b] shadow-md border-2 border-green-600 backdrop-blur-sm'
                }`}
            >
              <div className="w-4 h-4 border-2 border-green-600 rounded flex items-center justify-center">
                <div className="w-2 h-2 bg-green-600 rounded-full"></div>
              </div>
              <span>Veg</span>
              <span
                className={`px-2 py-1 rounded-full text-xs font-bold ${dietFilter === 'veg' ? 'bg-green-600 text-white' : 'bg-green-100 text-green-800'
                  }`}
              >
                {vegCount}
              </span>
            </button>

            <button
              onClick={() => setDietFilter('non-veg')}
              className={`flex items-center space-x-2 px-4 sm:px-6 py-2 sm:py-3 rounded-full font-medium transition-all duration-300 transform hover:scale-105 text-sm sm:text-base ${dietFilter === 'non-veg'
                ? 'bg-[#d92118] text-white shadow-lg scale-105 border border-[#ff4800]'
                : 'bg-white/90 text-[#d92118] hover:bg-[#ffd6d6] shadow-md border-2 border-[#d92118] backdrop-blur-sm'
                }`}
            >
              <div className="w-4 h-4 border-2 border-[#d92118] rounded flex items-center justify-center">
                <div className="w-2 h-2 bg-[#d92118] rounded-full"></div>
              </div>
              <span>Non-Veg</span>
              <span
                className={`px-2 py-1 rounded-full text-xs font-bold ${dietFilter === 'non-veg' ? 'bg-white text-[#d92118]' : 'bg-red-100 text-red-800'
                  }`}
              >
                {nonVegCount}
              </span>
            </button>
          </div>

          {/* Menu Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 sm:gap-8 lg:gap-10">
            {filteredItems.map((item) => {
              const qty = getQty(item.id);
              const unavailable = !item.isAvailable;

              return (
                <div
                  key={item.id}
                  className={`relative rounded-3xl overflow-hidden shadow-lg bg-white/95 backdrop-blur-sm transition-all duration-500 hover:-translate-y-2 hover:scale-105
                    ${unavailable ? 'opacity-50 cursor-not-allowed' : ''} 
                    ${item.isVeg ? 'border-2 border-green-200' : 'border-2 border-red-200'}`}
                >
                  {unavailable && (
                    <div className="absolute inset-0 bg-black/50 flex items-center justify-center rounded-3xl z-10">
                      <span className="text-white font-bold text-sm">Unavailable</span>
                    </div>
                  )}

                  <div className="p-5 sm:p-6">
                    <div className="text-center mb-4">
                      <img
                        src={item.image}
                        alt={item.name}
                        className="w-24 h-24 sm:w-28 sm:h-28 mx-auto mb-3 rounded-full object-cover shadow-lg animate-pulse"
                        loading="lazy"
                      />
                      <div className="flex items-center justify-center space-x-2 mb-2">
                        <div
                          className={`w-5 h-5 border-2 ${item.isVeg ? 'border-green-600' : 'border-[#d92118]'
                            } rounded flex items-center justify-center`}
                        >
                          <div
                            className={`w-2.5 h-2.5 rounded-full ${item.isVeg ? 'bg-green-600' : 'bg-[#d92118]'
                              }`}
                          ></div>
                        </div>
                        <span
                          className={`text-xs font-bold ${item.isVeg ? 'text-green-600' : 'text-[#d92118]'
                            }`}
                        >
                          {item.isVeg ? 'PURE VEG' : 'NON-VEG'}
                        </span>
                      </div>
                    </div>

                    <h3 className="text-lg sm:text-xl font-bold text-center text-[#2e3e7b] mb-2">
                      {item.name}
                      {item.size && <span className="text-sm text-gray-500"> ({item.size}")</span>}
                    </h3>

                    <p className="text-sm sm:text-base text-center text-[#2e3e7b]/80 mb-4 leading-relaxed">
                      {item.description}
                    </p>

                    <div className="flex items-center justify-between mb-4">
                      <div className="flex items-center space-x-1">
                        <Star className="w-4 h-4 text-[#ffb400] fill-current" />
                        <span className="text-sm font-medium text-[#2e3e7b]">{item.rating}</span>
                      </div>
                      <div className="text-xl sm:text-2xl font-bold bg-gradient-to-r from-[#ff4800] to-[#ffb400] bg-clip-text text-transparent">
                        ₹{item.price}
                      </div>
                    </div>

                    <div className="flex justify-center">
                      {qty === 0 ? (
                        <button
                          onClick={() => handleAddClick(item)}
                          disabled={unavailable}
                          className="flex items-center space-x-2 bg-gradient-to-r from-[#ff4800] to-[#ffb400] text-white font-semibold py-2.5 px-6 rounded-full shadow-md hover:shadow-lg transition-all duration-300 transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                          <span className="text-lg">+</span>
                          <span>Add</span>
                        </button>
                      ) : (
                        <div className="flex items-center bg-white border-2 border-[#ff4800] rounded-full overflow-hidden shadow-md">
                          <button
                            onClick={() => removeOne(item.id)}
                            className="w-10 h-10 flex items-center justify-center bg-gradient-to-r from-[#d92118] to-[#ff4800] text-white font-bold hover:from-[#ff4800] hover:to-[#ffb400] transition-all"
                          >
                            –
                          </button>
                          <div className="px-4 font-bold text-[#2e3e7b]">{qty}</div>
                          <button
                            onClick={() => handleAddClick(item)}
                            disabled={unavailable}
                            className="w-10 h-10 flex items-center justify-center bg-gradient-to-r from-[#ff4800] to-[#ffb400] text-white font-bold hover:from-[#ffb400] hover:to-[#fff900] transition-all disabled:opacity-50"
                          >
                            +
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {filteredItems.length === 0 && (
            <div className="text-center py-12 bg-white/90 backdrop-blur-sm rounded-3xl shadow-lg p-8">
              <div className="text-6xl mb-4">No items found</div>
              <h3 className="text-xl font-semibold text-[#2e3e7b] mb-2">No items found</h3>
              <p className="text-[#2e3e7b]/80">
                Try searching for something else or change your filter
              </p>
            </div>
          )}
        </div>
      </div>

      {/* ADDONS MODAL */}
      {showAddonsModal && currentItem && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-3xl shadow-2xl max-w-md w-full max-h-[80vh] overflow-y-auto p-6">
            <h2 className="text-2xl font-bold text-[#2e3e7b] mb-4">
              Customize Your {currentItem.name}
            </h2>

            <div className="space-y-3 mb-6">
              {addons.map((addon) => {
                const isSelected = selectedAddons.some((a) => a.id === addon.id);
                return (
                  <label
                    key={addon.id}
                    className={`flex items-center justify-between p-4 rounded-xl border-2 cursor-pointer transition-all ${isSelected ? 'border-[#ff4800] bg-orange-50' : 'border-gray-200 hover:border-[#ff4800]'
                      }`}
                  >
                    <div className="flex items-center space-x-3">
                      <input
                        type="checkbox"
                        checked={isSelected}
                        onChange={() => {
                          setSelectedAddons((prev) =>
                            isSelected
                              ? prev.filter((a) => a.id !== addon.id)
                              : [...prev, addon]
                          );
                        }}
                        className="w-5 h-5 text-[#ff4800] rounded focus:ring-[#ff4800]"
                      />
                      <div>
                        <p className="font-medium text-[#2e3e7b]">{addon.item_name}</p>
                        <p className="text-sm text-gray-500">
                          {addon.category_type === 'v' ? 'Veg' : 'Non-Veg'}
                        </p>
                      </div>
                    </div>
                    <p className="font-bold text-[#ff4800]">+₹{addon.final_price}</p>
                  </label>
                );
              })}
            </div>

            <div className="flex justify-between items-center mb-4">
              <p className="text-lg font-semibold text-[#2e3e7b]">
                Total:{' '}
                <span className="text-[#ff4800]">
                  ₹
                  {currentItem.price +
                    selectedAddons.reduce((sum, a) => sum + a.final_price, 0)}
                </span>
              </p>
            </div>

            <div className="flex gap-3">
              <button
                onClick={confirmAddWithAddons}
                className="flex-1 bg-gradient-to-r from-[#ff4800] to-[#ffb400] text-white font-bold py-3 rounded-full shadow-md hover:shadow-lg transition-all"
              >
                Add to Cart
              </button>
              <button
                onClick={() => {
                  setShowAddonsModal(false);
                  setCurrentItem(null);
                  setAddons([]);
                  setSelectedAddons([]);
                }}
                className="flex-1 bg-gray-200 text-[#2e3e7b] font-bold py-3 rounded-full hover:bg-gray-300 transition-all"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};










const Cart = ({ isOpen, setIsOpen, cart, setCart, setCurrentView }) => {
  const [isCheckoutOpen, setIsCheckoutOpen] = useState(false);

  /* ---------- KEY HELPERS (same as MenuPage) ---------- */
  const getItemKey = (item, addonsList = []) => {
    const sorted = (addonsList || []).map((a) => a.id).sort().join('-');
    return `${item.id}-${sorted}`;
  };

  /* ---------- UPDATE QUANTITY (by _key) ---------- */
  const updateQuantity = (key, change) => {
    setCart((prev) =>
      prev
        .map((item) => {
          if (item._key === key) {
            const newQty = Math.max(0, item.quantity + change);
            return newQty === 0 ? null : { ...item, quantity: newQty };
          }
          return item;
        })
        .filter(Boolean)
    );
  };

  /* ---------- REMOVE ITEM ---------- */
  const removeItem = (key) => {
    setCart((prev) => prev.filter((i) => i._key !== key));
  };

  /* ---------- TOTAL ---------- */
  const total = cart.reduce((sum, item) => {
    const price = item.totalPrice || item.price;
    return sum + price * item.quantity;
  }, 0);

  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[55]"
        onClick={() => setIsOpen(false)}
      />

      {/* Cart Sidebar */}
      <div className="fixed right-0 top-0 h-full w-full max-w-md bg-white shadow-2xl z-[56] overflow-y-auto">
        <div className="p-6 border-b bg-gradient-to-r from-[#ff4800] to-[#d92118] text-white">
          <div className="flex justify-between items-center">
            <h2 className="text-2xl font-bold">Your Cart ({cart.length})</h2>
            <button
              onClick={() => setIsOpen(false)}
              className="text-white/80 hover:text-white transition-colors"
            >
              <X className="w-6 h-6" />
            </button>
          </div>
        </div>

        <div className="flex-1 p-6">
          {cart.length === 0 ? (
            <div className="text-center py-16">
              <div className="text-7xl mb-4">Shopping Cart</div>
              <p className="text-gray-500 mb-8 text-lg">Your cart is empty</p>
              <button
                onClick={() => {
                  setIsOpen(false);
                  setCurrentView('menu');
                }}
                className="bg-gradient-to-r from-[#ff4800] to-[#ffb400] text-white px-8 py-3 rounded-full font-bold shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
              >
                Browse Menu
              </button>
            </div>
          ) : (
            <>
              {/* Cart Items */}
              {cart.map((item) => {
                const itemTotal = (item.totalPrice || item.price) * item.quantity;
                const hasAddons = item.addons && item.addons.length > 0;

                return (
                  <div
                    key={item._key}
                    className="mb-5 p-4 bg-white rounded-2xl border-2 border-gray-100 shadow-sm hover:shadow-md transition-all"
                  >
                    <div className="flex items-start space-x-4">
                      <img
                        src={item.image}
                        alt={item.name}
                        className="w-16 h-16 rounded-full object-cover shadow-md"
                        loading="lazy"
                      />

                      <div className="flex-1">
                        <h3 className="font-bold text-gray-800 text-lg">{item.name}</h3>
                        {item.size && (
                          <p className="text-sm text-gray-500">Size: {item.size}"</p>
                        )}

                        {/* Add‑ons */}
                        {hasAddons && (
                          <div className="mt-2 space-y-1">
                            {item.addons.map((addon, idx) => (
                              <div
                                key={idx}
                                className="text-xs text-gray-600 flex justify-between items-center"
                              >
                                <span className="flex items-center">
                                  <span className="mr-1">+</span> {addon.name}
                                </span>
                                <span className="font-medium text-[#ff4800]">
                                  +₹{addon.price}
                                </span>
                              </div>
                            ))}
                          </div>
                        )}

                        {/* Price */}
                        <div className="flex justify-between items-center mt-3">
                          <p className="text-lg font-bold text-[#ff4800]">
                            ₹{item.totalPrice || item.price} × {item.quantity} = ₹
                            {itemTotal}
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* Quantity Controls */}
                    <div className="flex items-center justify-between mt-4">
                      <div className="flex items-center bg-white border-2 border-[#ff4800] rounded-full overflow-hidden shadow-sm">
                        <button
                          onClick={() => updateQuantity(item._key, -1)}
                          className="w-10 h-10 flex items-center justify-center bg-gradient-to-r from-[#d92118] to-[#ff4800] text-white font-bold hover:from-[#ff4800] hover:to-[#ffb400] transition-all"
                        >
                          <Minus className="w-4 h-4" />
                        </button>
                        <div className="px-4 font-bold text-[#2e3e7b]">
                          {item.quantity}
                        </div>
                        <button
                          onClick={() => updateQuantity(item._key, 1)}
                          className="w-10 h-10 flex items-center justify-center bg-gradient-to-r from-[#ff4800] to-[#ffb400] text-white font-bold hover:from-[#ffb400] hover:to-[#fff900] transition-all"
                        >
                          <Plus className="w-4 h-4" />
                        </button>
                      </div>

                      <button
                        onClick={() => removeItem(item._key)}
                        className="text-red-500 hover:text-red-700 p-2 rounded-full hover:bg-red-50 transition-colors"
                      >
                        <X className="w-5 h-5" />
                      </button>
                    </div>
                  </div>
                );
              })}

              {/* Total & Checkout */}
              <div className="mt-8 pt-6 border-t bg-gradient-to-r from-[#fff9e1] to-white rounded-2xl p-5 shadow-lg">
                <div className="flex justify-between items-center text-2xl font-bold mb-5">
                  <span className="text-[#2e3e7b]">Grand Total</span>
                  <span className="bg-gradient-to-r from-[#ff4800] to-[#d92118] bg-clip-text text-transparent">
                    ₹{total}
                  </span>
                </div>

                <button
                  onClick={() => setIsCheckoutOpen(true)}
                  className="w-full bg-gradient-to-r from-[#ff4800] to-[#d92118] text-white py-4 rounded-full font-bold text-lg shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105"
                >
                  Proceed to Checkout
                </button>
              </div>
            </>
          )}
        </div>
      </div>

      {/* Checkout Modal */}
      <CheckoutModal
        isOpen={isCheckoutOpen}
        setIsOpen={setIsCheckoutOpen}
        total={total}
        cart={cart}
        setCart={setCart}
        setIsCartOpen={setIsOpen}
      />
    </>
  );
};



// // Dummy Checkout Modal (replace with real one)
// const CheckoutModal = ({ isOpen, setIsOpen, total, cart, setCart, setIsCartOpen }) => {
//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[60] flex items-center justify-center p-4">
//       <div className="bg-white rounded-3xl p-6 max-w-md w-full">
//         <h2 className="text-2xl font-bold mb-4">Checkout</h2>
//         <p className="text-gray-600 mb-6">
//           Total: <span className="font-bold text-orange-600">₹{total}</span>
//         </p>
//         <div className="flex gap-3">
//           <button
//             onClick={() => {
//               alert('Order placed successfully!');
//               setCart([]);
//               setIsOpen(false);
//               setIsCartOpen(false);
//             }}
//             className="flex-1 bg-green-500 text-white py-3 rounded-full font-bold"
//           >
//             Confirm Order
//           </button>
//           <button
//             onClick={() => setIsOpen(false)}
//             className="flex-1 bg-gray-200 text-gray-800 py-3 rounded-full font-bold"
//           >
//             Cancel
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Cart;

// Checkout Modal with Payment
// const CheckoutModal = ({ isOpen, setIsOpen, total, cart, setCart, setIsCartOpen }) => {
//   const [step, setStep] = useState('address'); // 'address', 'payment', 'success'
//   const [name, setName] = useState('');
//   const [address, setAddress] = useState('');
//   const [phone, setPhone] = useState('');

//   // Validation states
//   const [errors, setErrors] = useState({});

//   // Validation function
//   const validate = () => {
//     const newErrors = {};

//     if (!name.trim()) {
//       newErrors.name = 'Name is required';
//     }

//     if (!address.trim()) {
//       newErrors.address = 'Delivery address is required';
//     } else if (address.trim().length < 10) {
//       newErrors.address = 'Address must be at least 10 characters';
//     }

//     if (!phone.trim()) {
//       newErrors.phone = 'Phone number is required';
//     } else if (!/^\d{10}$/.test(phone.replace(/[\s()-]+/g, ''))) {
//       newErrors.phone = 'Enter a valid 10-digit phone number';
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleContinue = () => {
//     if (validate()) {
//       setStep('payment');
//     }
//   };

//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-[60] p-4">
//       <div className="bg-white rounded-2xl p-6 w-full max-w-lg shadow-2xl">
//         {step === 'address' && (
//           <>
//             <div className="flex justify-between items-center mb-6">
//               <h2 className="text-2xl font-bold text-gray-800">Delivery Details</h2>
//               <button onClick={() => setIsOpen(false)}>
//                 <X className="w-6 h-6 text-gray-400" />
//               </button>
//             </div>

//             <div className="space-y-4">
//               {/* Name Input */}
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                   Full Name <span className="text-red-500">*</span>
//                 </label>
//                 <input
//                   type="text"
//                   value={name}
//                   onChange={(e) => {
//                     setName(e.target.value);
//                     if (errors.name) setErrors({ ...errors, name: '' });
//                   }}
//                   placeholder="Enter your full name"
//                   className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none transition-all ${errors.name ? 'border-red-500' : 'border-gray-300'
//                     }`}
//                 />
//                 {errors.name && (
//                   <p className="text-red-500 text-xs mt-1">{errors.name}</p>
//                 )}
//               </div>

//               {/* Address Input */}
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                   Delivery Address <span className="text-red-500">*</span>
//                 </label>
//                 <textarea
//                   value={address}
//                   onChange={(e) => {
//                     setAddress(e.target.value);
//                     if (errors.address) setErrors({ ...errors, address: '' });
//                   }}
//                   placeholder="House no., street, area, landmark..."
//                   className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none transition-all resize-none ${errors.address ? 'border-red-500' : 'border-gray-300'
//                     }`}
//                   rows="3"
//                 />
//                 {errors.address && (
//                   <p className="text-red-500 text-xs mt-1">{errors.address}</p>
//                 )}
//               </div>

//               {/* Phone Input */}
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                   Phone Number <span className="text-red-500">*</span>
//                 </label>
//                 <input
//                   type="tel"
//                   value={phone}
//                   onChange={(e) => {
//                     const value = e.target.value.replace(/\D/g, '').slice(0, 10);
//                     setPhone(value);
//                     if (errors.phone) setErrors({ ...errors, phone: '' });
//                   }}
//                   placeholder="e.g. 9876543210"
//                   className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none transition-all ${errors.phone ? 'border-red-500' : 'border-gray-300'
//                     }`}
//                 />
//                 {errors.phone && (
//                   <p className="text-red-500 text-xs mt-1">{errors.phone}</p>
//                 )}
//               </div>

//               {/* Order Summary */}
//               <div className="bg-gray-50 p-4 rounded-lg">
//                 <h3 className="font-medium text-gray-800 mb-2">Order Summary</h3>
//                 {cart.map(item => (
//                   <div key={item.id} className="flex justify-between text-sm text-gray-600 mb-1">
//                     <span>{item.name} x {item.quantity}</span>
//                     <span>₹{item.price * item.quantity}</span>
//                   </div>
//                 ))}
//                 <div className="border-t pt-2 mt-2">
//                   <div className="flex justify-between font-bold text-gray-800">
//                     <span>Total</span>
//                     <span>₹{total}</span>
//                   </div>
//                 </div>
//               </div>

//               {/* Continue Button */}
//               <button
//                 onClick={handleContinue}
//                 disabled={!name.trim() || !address.trim() || !phone.trim()}
//                 className="w-full bg-gradient-to-r from-orange-500 to-red-500 text-white py-3 rounded-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed font-medium transition-all duration-300 transform hover:scale-105"
//               >
//                 Continue to Payment
//               </button>
//             </div>
//           </>
//         )}

//         {/* {step === 'payment' && (
//           <RazorpayPayment themeColor="#3399cc" amount={total} name={name} address={address}/>
//         )} */}
//         {/* // ... inside CheckoutModal (only the payment branch changes) */}

//         {step === "payment" && (
//           <RazorpayPayment
//             amount={total}
//             name={name}
//             address={address}
//             phone={phone}
//             cart={cart}
//             onSuccess={(paymentId) => {
//               // 1. Clear cart
//               setCart([]);
//               // 2. Show success step (you already have a success UI)
//               setStep("success");
//               // optional: store paymentId somewhere if you need it later
//             }}
//             onCancel={() => setStep("address")} // go back to address step
//           />
//         )}

//         {step === 'success' && (
//           <div className="text-center py-8">
//             <div className="text-6xl mb-4">Success</div>
//             <h2 className="text-2xl font-bold text-green-600 mb-4">Order Placed Successfully!</h2>
//             <p className="text-gray-600 mb-6">
//               Your delicious food will be delivered in 25-30 minutes.
//             </p>
//             <div className="bg-green-50 border border-green-200 p-4 rounded-lg">
//               <p className="text-sm text-green-700">
//                 Order ID: #OYP{Math.random().toString(36).substr(2, 9).toUpperCase()}
//               </p>
//               <p className="text-sm text-green-700 mt-1">
//                 Track your order via SMS updates
//               </p>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };






const CheckoutModal = ({
  isOpen,
  setIsOpen,
  total,
  cart,
  setCart,
  setIsCartOpen,
}) => {
  /* ---------------------------------------------------------- */
  /* 1. STATE */
  /* ---------------------------------------------------------- */
  const [mode, setMode] = useState(null);
  const [step, setStep] = useState('mode');

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phone, setPhone] = useState('');
  const [flat, setFlat] = useState('');
  const [area, setArea] = useState('');
  const [landmark, setLandmark] = useState('');
  const [pincode, setPincode] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [usingLocation, setUsingLocation] = useState(false);
  const [errors, setErrors] = useState({});

  /* ---------------------------------------------------------- */
  /* 2. RESET ON CLOSE → Always start at Delivery/Takeaway */
  /* ---------------------------------------------------------- */
  useEffect(() => {
    if (!isOpen) {
      setMode(null);
      setStep('mode');
      setFirstName('');
      setLastName('');
      setPhone('');
      setFlat('');
      setArea('');
      setLandmark('');
      setPincode('');
      setCity('');
      setState('');
      setErrors({});
    }
  }, [isOpen]);

  /* ---------------------------------------------------------- */
  /* 3. VALIDATION */
  /* ---------------------------------------------------------- */
  const validateDelivery = () => {
    const newErrors = {};
    if (!firstName.trim()) newErrors.firstName = 'First name is required';
    if (!lastName.trim()) newErrors.lastName = 'Last name is required';
    const cleanPhone = phone.replace(/\D/g, '');
    if (!cleanPhone) newErrors.phone = 'Phone number is required';
    else if (cleanPhone.length !== 10) newErrors.phone = 'Enter a valid 10-digit phone number';
    if (!flat.trim()) newErrors.flat = 'Flat/House no. is required';
    if (!area.trim()) newErrors.area = 'Area/Street is required';
    const cleanPin = pincode.replace(/\D/g, '');
    if (!cleanPin) newErrors.pincode = 'Pincode is required';
    else if (cleanPin.length !== 6) newErrors.pincode = 'Enter a valid 6-digit pincode';
    if (!city.trim()) newErrors.city = 'Town/City is required';
    if (!state.trim()) newErrors.state = 'State is required';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  /* ---------------------------------------------------------- */
  /* 4. STEP HANDLERS */
  /* ---------------------------------------------------------- */
  const handleContinueFromMode = () => {
    if (mode === 'delivery') setStep('address');
    else setStep('takeawayPay');
  };

  const handleContinueFromAddress = () => {
    if (validateDelivery()) setStep('payment');
  };

  const handleTakeawayPay = (online) => {
    if (online) setStep('payment');
    else {
      setCart([]);
      setStep('success');
    }
  };

  /* ---------------------------------------------------------- */
  /* 5. GEOLOCATION */
  /* ---------------------------------------------------------- */
  const handleUseLocation = () => {
    if (!navigator.geolocation) {
      alert('Geolocation is not supported');
      return;
    }
    setUsingLocation(true);
    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        try {
          const res = await fetch(
            `https://nominatim.openstreetmap.org/reverse?lat=${pos.coords.latitude}&lon=${pos.coords.longitude}&format=json`
          );
          const data = await res.json();
          const a = data.address;
          setFlat(a.house_number || a.building || '');
          setArea([a.road, a.neighbourhood, a.suburb].filter(Boolean).join(', '));
          setLandmark(a.landmark || '');
          setPincode(a.postcode || '');
          setCity(a.city || a.town || a.village || '');
          setState(a.state || '');
        } catch {
          alert('Could not fetch address. Enter manually.');
        } finally {
          setUsingLocation(false);
        }
      },
      () => {
        alert('Location denied');
        setUsingLocation(false);
      }
    );
  };

  if (!isOpen) return null;

  /* ---------------------------------------------------------- */
  /* 6. HEADER TITLE – Only ONE */
  /* ---------------------------------------------------------- */
  const getTitle = () => {
    if (step === 'mode') return 'How would you like to receive your order?';
    if (step === 'address') return 'Delivery Address';
    if (step === 'takeawayPay') return 'Choose Payment';
    if (step === 'payment') return 'Secure Payment';
    if (step === 'success') return 'Order Confirmed';
    return '';
  };

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-md flex items-center justify-center z-[70] p-4 animate-fadeIn">
      <div className="bg-white rounded-3xl w-full max-w-2xl shadow-2xl overflow-hidden animate-slideUp">

        {/* ───── SINGLE HEADER WITH ONE CLOSE BUTTON ───── */}
        <div className="flex items-center justify-between p-6 bg-gradient-to-r from-orange-500 to-red-600 text-white">
          <h2 className="text-2xl font-bold">{getTitle()}</h2>
          <button
            onClick={() => setIsOpen(false)}
            className="p-2 rounded-full hover:bg-white/20 transition"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        {/* ───── ALL STEPS (with padding below header) ───── */}
        <div className="p-6"> {/* ← This adds space below header */}

          {/* STEP 0: MODE */}
          {step === 'mode' && (
            <div className="space-y-8">
              <div className="grid grid-cols-2 gap-6">
                <button
                  onClick={() => setMode('delivery')}
                  className={`group relative p-8 rounded-2xl border-2 transition-all duration-300 ${
                    mode === 'delivery'
                      ? 'border-orange-500 bg-orange-50 shadow-xl scale-105'
                      : 'border-gray-200 hover:border-orange-300 hover:shadow-lg'
                  }`}
                >
                  <div className="flex flex-col items-center space-y-3">
                    <div className="p-4 rounded-full bg-orange-100 group-hover:bg-orange-200 transition">
                      <Truck className="w-10 h-10 text-orange-600" />
                    </div>
                    <p className="text-2xl font-bold text-gray-800">Delivery</p>
                    <p className="text-sm text-gray-600">Delivered to you</p>
                  </div>
                  {mode === 'delivery' && (
                    <CheckCircle className="absolute top-4 right-4 w-7 h-7 text-orange-600" />
                  )}
                </button>

                <button
                  onClick={() => setMode('takeaway')}
                  className={`group relative p-8 rounded-2xl border-2 transition-all duration-300 ${
                    mode === 'takeaway'
                      ? 'border-orange-500 bg-orange-50 shadow-xl scale-105'
                      : 'border-gray-200 hover:border-orange-300 hover:shadow-lg'
                  }`}
                >
                  <div className="flex flex-col items-center space-y-3">
                    <div className="p-4 rounded-full bg-emerald-100 group-hover:bg-emerald-200 transition">
                      <Store className="w-10 h-10 text-emerald-600" />
                    </div>
                    <p className="text-2xl font-bold text-gray-800">Take Away</p>
                    <p className="text-sm text-gray-600">Pick up yourself</p>
                  </div>
                  {mode === 'takeaway' && (
                    <CheckCircle className="absolute top-4 right-4 w-7 h-7 text-orange-600" />
                  )}
                </button>
              </div>

              <button
                onClick={handleContinueFromMode}
                disabled={!mode}
                className="w-full py-4 rounded-full font-bold text-lg bg-gradient-to-r from-orange-500 to-red-600 text-white shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed transition-all transform hover:scale-105"
              >
                Continue
              </button>
            </div>
          )}

          {/* STEP 1: ADDRESS */}
          {step === 'address' && (
            <div className="space-y-6 max-h-[70vh] overflow-y-auto">
              {/* Name */}
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-1">
                    First Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    value={firstName}
                    onChange={(e) => {
                      setFirstName(e.target.value);
                      if (errors.firstName) setErrors({ ...errors, firstName: '' });
                    }}
                    placeholder="John"
                    className={`w-full px-4 py-3 rounded-xl border focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none transition-all ${
                      errors.firstName ? 'border-red-500' : 'border-gray-300'
                    }`}
                  />
                  {errors.firstName && <p className="text-red-500 text-xs mt-1">{errors.firstName}</p>}
                </div>
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-1">
                    Last Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    value={lastName}
                    onChange={(e) => {
                      setLastName(e.target.value);
                      if (errors.lastName) setErrors({ ...errors, lastName: '' });
                    }}
                    placeholder="Doe"
                    className={`w-full px-4 py-3 rounded-xl border focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none transition-all ${
                      errors.lastName ? 'border-red-500' : 'border-gray-300'
                    }`}
                  />
                  {errors.lastName && <p className="text-red-500 text-xs mt-1">{errors.lastName}</p>}
                </div>
              </div>

              {/* Phone */}
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1">
                  Phone Number <span className="text-red-500">*</span>
                </label>
                <input
                  type="tel"
                  value={phone}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, '').slice(0, 10);
                    setPhone(value);
                    if (errors.phone) setErrors({ ...errors, phone: '' });
                  }}
                  placeholder="9876543210"
                  className={`w-full px-4 py-3 rounded-xl border focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none transition-all ${
                    errors.phone ? 'border-red-500' : 'border-gray-300'
                  }`}
                />
                {errors.phone && <p className="text-red-500 text-xs mt-1">{errors.phone}</p>}
              </div>

              {/* Use My Location */}
              <button
                onClick={handleUseLocation}
                disabled={usingLocation}
                className="w-full flex items-center justify-center gap-2 py-3 rounded-xl bg-gradient-to-r from-blue-500 to-blue-600 text-white font-medium shadow-md hover:shadow-lg disabled:opacity-50 transition-all"
              >
                <MapPin className="w-5 h-5" />
                {usingLocation ? 'Fetching...' : 'Use My Location'}
              </button>

              {/* Address Fields */}
              {[
                { label: 'Flat, House no., Building *', state: flat, set: setFlat, err: 'flat' },
                { label: 'Area, Street, Sector *', state: area, set: setArea, err: 'area' },
                { label: 'Landmark (Optional)', state: landmark, set: setLandmark },
                { label: 'Pincode *', state: pincode, set: setPincode, err: 'pincode', max: 6 },
                { label: 'Town/City *', state: city, set: setCity, err: 'city' },
                { label: 'State *', state: state, set: setState, err: 'state' },
              ].map((field) => (
                <div key={field.label}>
                  <label className="block text-sm font-semibold text-gray-700 mb-1">
                    {field.label}
                  </label>
                  <input
                    type="text"
                    value={field.state}
                    onChange={(e) => {
                      let val = e.target.value;
                      if (field.max) val = val.replace(/\D/g, '').slice(0, field.max);
                      field.set(val);
                      if (field.err && errors[field.err])
                        setErrors({ ...errors, [field.err]: '' });
                    }}
                    placeholder={field.label.includes('Pincode') ? '6-digit pincode' : ''}
                    className={`w-full px-4 py-3 rounded-xl border focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none transition-all ${
                      field.err && errors[field.err] ? 'border-red-500' : 'border-gray-300'
                    }`}
                  />
                  {field.err && errors[field.err] && (
                    <p className="text-red-500 text-xs mt-1">{errors[field.err]}</p>
                  )}
                </div>
              ))}

              {/* Order Summary */}
              <div className="bg-gradient-to-br from-amber-50 to-white p-5 rounded-2xl border border-amber-200">
                <h3 className="font-bold text-lg text-gray-800 mb-3">Order Summary</h3>
                <div className="space-y-3 max-h-48 overflow-y-auto">
                  {cart.map((item) => {
                    const itemTotal = (item.totalPrice || item.price) * item.quantity;
                    const hasAddons = item.addons && item.addons.length > 0;
                    return (
                      <div key={item._key} className="flex items-center gap-3 p-3 bg-white rounded-xl shadow-sm">
                        <img src={item.image} alt={item.name} className="w-12 h-12 rounded-full object-cover" loading="lazy" />
                        <div className="flex-1">
                          <p className="font-medium text-gray-800">{item.name}</p>
                          {item.size && <p className="text-xs text-gray-500">Size: {item.size}"</p>}
                          {hasAddons && (
                            <p className="text-xs text-gray-600">
                              {item.addons.map((a, i) => (
                                <span key={i}>{i > 0 && ', '} +{a.name}</span>
                              ))}
                            </p>
                          )}
                          <p className="text-sm font-bold text-orange-600">
                            ₹{item.totalPrice || item.price} × {item.quantity} = ₹{itemTotal}
                          </p>
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div className="mt-4 pt-3 border-t border-amber-200">
                  <div className="flex justify-between text-xl font-bold">
                    <span className="text-gray-800">Grand Total</span>
                    <span className="bg-gradient-to-r from-orange-500 to-red-600 bg-clip-text text-transparent">
                      ₹{total}
                    </span>
                  </div>
                </div>
              </div>

              <button
                onClick={handleContinueFromAddress}
                className="w-full py-4 rounded-full font-bold text-lg bg-gradient-to-r from-orange-500 to-red-600 text-white shadow-lg hover:shadow-xl transition-all transform hover:scale-105"
              >
                Continue to Payment
              </button>
            </div>
          )}

          {/* STEP: TAKEAWAY PAY CHOICE */}
          {step === 'takeawayPay' && (
            <div className="space-y-8">
              <h3 className="text-xl font-semibold text-center text-gray-800">
                How would you like to pay?
              </h3>
              <div className="grid grid-cols-1 gap-6">
                <button
                  onClick={() => handleTakeawayPay(true)}
                  className="group flex items-center justify-between p-6 rounded-2xl border-2 border-gray-200 hover:border-orange-400 hover:shadow-lg transition-all"
                >
                  <div className="flex items-center space-x-4">
                    <div className="p-3 rounded-full bg-orange-100 group-hover:bg-orange-200 transition">
                      <CreditCard className="w-8 h-8 text-orange-600" />
                    </div>
                    <div className="text-left">
                      <p className="font-bold text-gray-800">Pay Online</p>
                      <p className="text-sm text-gray-600">Razorpay, UPI, Cards</p>
                    </div>
                  </div>
                  {/* <div className="text-orange-600">Right Arrow</div> */}
                </button>

                <button
                  onClick={() => handleTakeawayPay(false)}
                  className="group flex items-center justify-between p-6 rounded-2xl border-2 border-gray-200 hover:border-emerald-400 hover:shadow-lg transition-all"
                >
                  <div className="flex items-center space-x-4">
                    <div className="p-3 rounded-full bg-emerald-100 group-hover:bg-emerald-200 transition">
                      <HandCoins className="w-8 h-8 text-emerald-600" />
                    </div>
                    <div className="text-left">
                      <p className="font-bold text-gray-800">Pay In-Person</p>
                      <p className="text-sm text-gray-600">Cash / Card at counter</p>
                    </div>
                  </div>
                  {/* <div className="text-emerald-600">Right Arrow</div> */}
                </button>
              </div>
            </div>
          )}

          {/* STEP: PAYMENT */}
          {step === 'payment' && (
            <RazorpayPayment
              amount={total}
              name={mode === 'delivery' ? `${firstName} ${lastName}` : 'Take Away Customer'}
              address={
                mode === 'delivery'
                  ? `${flat}, ${area}${landmark ? ', ' + landmark : ''}, ${city}, ${state} - ${pincode}`
                  : 'Take Away'
              }
              phone={phone}
              cart={cart}
              onSuccess={() => {
                setCart([]);
                setStep('success');
              }}
              onCancel={() => setStep(mode === 'delivery' ? 'address' : 'takeawayPay')}
            />
          )}

          {/* STEP: SUCCESS */}
          {step === 'success' && (
            <div className="text-center space-y-6 py-10">
              <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-green-100 animate-bounce">
                <CheckCircle className="w-14 h-14 text-green-600" />
              </div>
              <h2 className="text-3xl font-bold text-green-600">Order Placed!</h2>
              <p className="text-gray-600 text-lg">
                {mode === 'delivery'
                  ? 'Your delicious meal is on the way! Estimated delivery: 25-30 mins'
                  : 'Your order is ready for pickup. Head to the counter!'}
              </p>
              <div className="bg-green-50 border border-green-200 p-6 rounded-2xl max-w-sm mx-auto">
                <p className="text-sm font-medium text-green-800">
                  Order ID:{' '}
                  <span className="font-mono text-green-900">
                    OYP{Math.random().toString(36).substr(2, 9).toUpperCase()}
                  </span>
                </p>
                <p className="text-xs text-green-700 mt-2">
                  SMS updates will be sent to {phone}
                </p>
              </div>
              <button
                onClick={() => {
                  setIsOpen(false);
                  setIsCartOpen(false);
                }}
                className="w-full max-w-xs mx-auto py-4 rounded-full font-bold text-lg bg-gradient-to-r from-green-500 to-emerald-600 text-white shadow-lg hover:shadow-xl transition-all transform hover:scale-105"
              >
                Done
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};








// About Page Component
const AboutPage = () => {
  return (
    <div className="pt-24 min-h-screen bg-[#fcf9e1]">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12">

        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-5xl sm:text-6xl font-extrabold bg-gradient-to-r from-[#ff4800] to-[#d92118] bg-clip-text text-transparent mb-4">
            About OyePai
          </h1>
          <p className="text-xl sm:text-2xl text-[#2e3e7b] font-medium">
            Eat Love Repeat - Your Perfect Hangout Destination
          </p>
        </div>

        {/* Story + Specialties */}
        <section className="py-16 md:py-24 bg-gradient-to-br from-orange-50 to-amber-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">

              {/* Left: Our Story Text */}
              <div className="order-2 lg:order-1">
                <div className="inline-flex items-center gap-2 text-orange-600 font-semibold text-sm uppercase tracking-wider mb-4">
                  <span className="w-12 h-px bg-orange-500"></span>
                  Our Journey
                </div>

                <h2 className="text-4xl md:text-5xl font-bold text-orange-900 mb-6 leading-tight">
                  Our Story
                </h2>

                <div className="prose prose-lg text-orange-800 space-y-4">
                  <p>
                    Welcome to <span className="font-bold text-orange-600">OyePai</span> — your neighborhood destination for the best pizza and burgers in Thiruvallur!
                  </p>
                  <p>
                    We started our journey in <strong>2021</strong>, in a humble <em>300 sq. ft. kitchen</em>, driven by one goal — to serve fresh, delicious food made with love and honesty. What began as a small idea quickly became a local favorite for foodies who crave authentic taste and quick, friendly service.
                  </p>
                  <p>
                    At OyePai, we make every dish with <span className="text-orange-600 font-semibold">fresh ingredients, homemade sauces, and handcrafted recipes</span> to ensure every bite bursts with flavor. Whether it’s our cheesy pizzas, juicy burgers, crispy wings, or momos, we’re all about quality, taste, and happiness.
                  </p>
                  <p>
                    More than just a restaurant, OyePai is a place to <strong>hang out, laugh, and create memories</strong> with friends and family. We believe food isn’t just about eating — it’s about connection, comfort, and joy.
                  </p>
                  <p className="italic text-orange-700">
                    With fast delivery and a growing community of loyal customers, OyePai continues to bring flavor, fun, and freshness to every doorstep in Thiruvallur and beyond.
                  </p>
                  <p className="text-2xl font-bold text-orange-600 mt-6">
                    Eat. Love. Repeat. — That’s the <span className="text-red-500">OyePai</span> way! ❤️
                  </p>
                </div>
              </div>

              {/* Right: Specialties Visual */}
              <div className="order-1 lg:order-2">
                <div className="relative">
                  {/* Floating Pizza */}
                  <div className="absolute -top-8 -left-8 text-8xl animate-bounce drop-shadow-lg">
                    🍕
                  </div>

                  {/* Specialties Card */}
                  <div className="bg-white/80 backdrop-blur-sm p-8 rounded-3xl shadow-xl border border-orange-200">
                    <h3 className="text-2xl md:text-3xl font-bold text-orange-900 mb-8 text-center">
                      Our Specialties
                    </h3>

                    <div className="grid grid-cols-3 gap-6 text-5xl sm:text-6xl">
                      <div className="group">
                        <div className="p-4 rounded-2xl bg-orange-100 text-orange-600 group-hover:bg-orange-500 group-hover:text-white transition-all duration-300 shadow-md">
                          🍕
                        </div>
                      </div>
                      <div className="group">
                        <div className="p-4 rounded-2xl bg-amber-100 text-amber-600 group-hover:bg-amber-500 group-hover:text-white transition-all duration-300 shadow-md">
                          🍔
                        </div>
                      </div>
                      <div className="group">
                        <div className="p-4 rounded-2xl bg-red-100 text-red-600 group-hover:bg-red-500 group-hover:text-white transition-all duration-300 shadow-md">
                          🍝
                        </div>
                      </div>
                      <div className="group">
                        <div className="p-4 rounded-2xl bg-yellow-100 text-yellow-600 group-hover:bg-yellow-500 group-hover:text-white transition-all duration-300 shadow-md">
                          🥪
                        </div>
                      </div>
                      <div className="group">
                        <div className="p-4 rounded-2xl bg-pink-100 text-pink-600 group-hover:bg-pink-500 group-hover:text-white transition-all duration-300 shadow-md">
                          🥟
                        </div>
                      </div>
                      <div className="group">
                        <div className="p-4 rounded-2xl bg-orange-100 text-orange-600 group-hover:bg-orange-500 group-hover:text-white transition-all duration-300 shadow-md">
                          🍗
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </section>

        <section className="py-16 md:py-24 bg-gradient-to-b from-orange-50 to-amber-50 relative overflow-hidden">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
            <div className="bg-white/90 backdrop-blur-sm rounded-3xl shadow-2xl p-8 md:p-12">

              {/* Section Title */}
              <div className="text-center mb-12">
                <div className="inline-flex items-center gap-3 text-orange-600 font-semibold text-sm uppercase tracking-wider mb-4">
                  <span className="w-16 h-px bg-orange-500"></span>
                  What Makes Us Different
                </div>
                <h2 className="text-4xl md:text-5xl font-bold text-orange-900">
                  Why We're Special
                </h2>
              </div>

              {/* Cards Grid */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative">

                {/* Floating Pizza (Top-left) */}
                <div className="absolute -top-8 -left-8 md:-top-12 md:-left-12 text-6xl md:text-8xl animate-bounce-slow opacity-30 pointer-events-none">
                  🍔
                </div>

                {/* Floating Burger (Bottom-right) */}
                <div className="absolute -bottom-8 -right-8 md:-bottom-12 md:-right-12 text-6xl md:text-8xl animate-bounce-slow opacity-30 pointer-events-none" style={{ animationDelay: '0.5s' }}>
                  🍕
                </div>

                {/* Quality Ingredients */}
                <div className="group text-center p-6 rounded-2xl bg-gradient-to-br from-orange-100 to-amber-50 border-2 border-orange-300 hover:border-orange-500 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
                  <div className="w-16 h-16 mx-auto mb-4 bg-orange-500 text-white rounded-full flex items-center justify-center shadow-lg group-hover:bg-orange-600 group-hover:shadow-xl transition-all">
                    <Star className="w-9 h-9" />
                  </div>
                  <h3 className="text-xl md:text-2xl font-bold text-orange-900 mb-2">
                    Quality Ingredients
                  </h3>
                  <p className="text-orange-700 text-sm leading-relaxed">
                    We use only the freshest, highest quality ingredients in all our dishes.
                  </p>
                </div>

                {/* Made with Love */}
                <div className="group text-center p-6 rounded-2xl bg-gradient-to-br from-red-100 to-orange-50 border-2 border-red-300 hover:border-red-500 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
                  <div className="w-16 h-16 mx-auto mb-4 bg-red-500 text-white rounded-full flex items-center justify-center shadow-lg group-hover:bg-red-600 group-hover:shadow-xl transition-all">
                    <Heart className="w-9 h-9 fill-current" />
                  </div>
                  <h3 className="text-xl md:text-2xl font-bold text-red-900 mb-2">
                    Made with Love
                  </h3>
                  <p className="text-red-700 text-sm leading-relaxed">
                    Every dish is prepared with care and passion by our expert chefs.
                  </p>
                </div>

                {/* Community First */}
                <div className="group text-center p-6 rounded-2xl bg-gradient-to-br from-amber-100 to-yellow-50 border-2 border-amber-300 hover:border-amber-500 hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1">
                  <div className="w-16 h-16 mx-auto mb-4 bg-amber-500 text-white rounded-full flex items-center justify-center shadow-lg group-hover:bg-amber-600 group-hover:shadow-xl transition-all">
                    <Users className="w-9 h-9" />
                  </div>
                  <h3 className="text-xl md:text-2xl font-bold text-amber-900 mb-2">
                    Community First
                  </h3>
                  <p className="text-amber-700 text-sm leading-relaxed">
                    We're proud to be part of the Thiruvallur community and serve our neighbors.
                  </p>
                </div>

              </div>
            </div>
          </div>

          {/* Custom Animation (Add to your CSS or Tailwind config) */}
          <style jsx>{`
    @keyframes bounce-slow {
      0%, 100% {
        transform: translateY(0);
      }
      50% {
        transform: translateY(-20px);
      }
    }
    .animate-bounce-slow {
      animation: bounce-slow 3s ease-in-out infinite;
    }
  `}</style>
        </section>

        {/* CTA */}
        <div className="text-center mt-16">
          <button className="px-8 py-4 rounded-full font-bold text-white bg-gradient-to-r from-[#ff4800] to-[#d92118] shadow-2xl hover:scale-105 transform transition-all duration-300">
            Visit Us Today!
          </button>
        </div>
      </div>
    </div>
  );
};

// Contact Page Component
// Contact Page Component

// Contact Page Component




const DineInBooking = () => {
  const [step, setStep] = useState(1);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);
  const [partySize, setPartySize] = useState(2);
  const [isSubmitted, setIsSubmitted] = useState(false);

  // Available time slots (11 AM - 11 PM)
  const timeSlots = [
    '11:00 AM', '11:30 AM',
    '12:00 PM', '12:30 PM', '01:00 PM', '01:30 PM',
    '02:00 PM', '02:30 PM', '03:00 PM', '03:30 PM',
    '06:00 PM', '06:30 PM', '07:00 PM', '07:30 PM',
    '08:00 PM', '08:30 PM', '09:00 PM', '09:30 PM',
    '10:00 PM', '10:30 PM'
  ];

  const handleSubmit = () => {
    setIsSubmitted(true);
    setTimeout(() => {
      setIsSubmitted(false);
      setStep(1);
      setSelectedDate(null);
      setSelectedTime(null);
      setPartySize(2);
    }, 4000);
  };

  return (
    <section className="py-16 mt-12 md:py-24 bg-gradient-to-br from-orange-50 to-amber-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 text-orange-600 font-semibold text-sm uppercase tracking-wider mb-4">
            <span className="w-12 h-px bg-orange-500"></span>
            Reserve Your Table
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-orange-900 mb-4">
            Dine-In Booking
          </h2>
          <p className="text-lg text-orange-700">
            Enjoy a cozy meal with us — book your table in just 3 steps!
          </p>
        </div>

        {/* Progress Steps */}
        <div className="flex justify-center items-center gap-4 mb-12">
          {[1, 2, 3].map((s) => (
            <div key={s} className="flex items-center">
              <div
                className={`w-12 h-12 rounded-full flex items-center justify-center font-bold transition-all duration-300 ${
                  step >= s
                    ? 'bg-orange-500 text-white shadow-lg'
                    : 'bg-orange-200 text-orange-600'
                }`}
              >
                {step > s ? <Check className="w-6 h-6" /> : s}
              </div>
              {s < 3 && (
                <div
                  className={`w-20 h-1 transition-all duration-300 ${
                    step > s ? 'bg-orange-500' : 'bg-orange-200'
                  }`}
                />
              )}
            </div>
          ))}
        </div>

        {/* Step Content */}
        <div className="bg-white rounded-3xl shadow-2xl p-6 md:p-10">

          {/* Step 1: Choose Date */}
          {step === 1 && (
            <div className="space-y-6">
              <div className="flex items-center gap-3 text-orange-800 mb-4">
                <Calendar className="w-6 h-6" />
                <h3 className="text-xl font-bold">Select Date</h3>
              </div>
              <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 gap-3">
                {[...Array(15)].map((_, i) => {
                  const date = new Date();
                  date.setDate(date.getDate() + i);
                  const isSelected = selectedDate && format(selectedDate, 'yyyy-MM-dd') === format(date, 'yyyy-MM-dd');
                  const isToday = i === 0;
                  return (
                    <button
                      key={i}
                      onClick={() => setSelectedDate(date)}
                      className={`p-4 rounded-2xl border-2 transition-all duration-300 ${
                        isSelected
                          ? 'border-orange-500 bg-orange-50 text-orange-900 shadow-md'
                          : 'border-orange-200 hover:border-orange-400 hover:bg-orange-50'
                      }`}
                    >
                      <div className="text-xs font-medium text-orange-600">
                        {isToday ? 'Today' : format(date, 'EEE')}
                      </div>
                      <div className="text-lg font-bold">{format(date, 'dd')}</div>
                      <div className="text-xs text-orange-500">{format(date, 'MMM')}</div>
                    </button>
                  );
                })}
              </div>
              <button
                onClick={() => setStep(2)}
                disabled={!selectedDate}
                className="w-full mt-6 bg-gradient-to-r from-orange-500 to-red-500 text-white py-3 rounded-2xl font-bold hover:shadow-lg transition-all duration-300 transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
              >
                Next <ChevronRight className="w-5 h-5" />
              </button>
            </div>
          )}

          {/* Step 2: Choose Time */}
          {step === 2 && (
            <div className="space-y-6">
              <div className="flex items-center gap-3 text-orange-800 mb-4">
                <Clock className="w-6 h-6" />
                <h3 className="text-xl font-bold">Select Time</h3>
              </div>
              <div className="grid grid-cols-3 sm:grid-cols-4 gap-3">
                {timeSlots.map((time) => (
                  <button
                    key={time}
                    onClick={() => setSelectedTime(time)}
                    className={`p-3 rounded-xl border-2 text-sm font-medium transition-all duration-300 ${
                      selectedTime === time
                        ? 'border-orange-500 bg-orange-50 text-orange-900 shadow-md'
                        : 'border-orange-200 hover:border-orange-400 hover:bg-orange-50'
                    }`}
                  >
                    {time}
                  </button>
                ))}
              </div>
              <div className="flex gap-3 mt-6">
                <button
                  onClick={() => setStep(1)}
                  className="flex-1 bg-gray-200 text-gray-700 py-3 rounded-2xl font-bold hover:bg-gray-300 transition-all"
                >
                  Back
                </button>
                <button
                  onClick={() => setStep(3)}
                  disabled={!selectedTime}
                  className="flex-1 bg-gradient-to-r from-orange-500 to-red-500 text-white py-3 rounded-2xl font-bold hover:shadow-lg transition-all duration-300 transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                >
                  Next <ChevronRight className="w-5 h-5" />
                </button>
              </div>
            </div>
          )}

          {/* Step 3: Party Size & Confirm */}
          {step === 3 && (
            <div className="space-y-6">
              <div className="flex items-center gap-3 text-orange-800 mb-4">
                <Users className="w-6 h-6" />
                <h3 className="text-xl font-bold">Party Size</h3>
              </div>

              <div className="flex justify-center items-center gap-4">
                <button
                  onClick={() => setPartySize(Math.max(1, partySize - 1))}
                  className="w-12 h-12 rounded-full bg-orange-100 text-orange-600 hover:bg-orange-200 transition-all text-xl font-bold"
                >
                  −
                </button>
                <div className="text-3xl font-bold text-orange-900 w-20 text-center">
                  {partySize}
                </div>
                <button
                  onClick={() => setPartySize(partySize + 1)}
                  className="w-12 h-12 rounded-full bg-orange-100 text-orange-600 hover:bg-orange-200 transition-all text-xl font-bold"
                >
                  +
                </button>
              </div>

              <div className="bg-orange-50 rounded-2xl p-6 mt-8 space-y-3 text-orange-800">
                <div className="flex justify-between">
                  <span className="font-medium">Date:</span>
                  <span className="font-bold">{selectedDate ? format(selectedDate, 'EEEE, MMM dd') : '-'}</span>
                </div>
                <div className="flex justify-between">
                  <span className="font-medium">Time:</span>
                  <span className="font-bold">{selectedTime || '-'}</span>
                </div>
                <div className="flex justify-between">
                  <span className="font-medium">Guests:</span>
                  <span className="font-bold">{partySize} {partySize === 1 ? 'Guest' : 'Guests'}</span>
                </div>
              </div>

              <div className="flex gap-3 mt-6">
                <button
                  onClick={() => setStep(2)}
                  className="flex-1 bg-gray-200 text-gray-700 py-3 rounded-2xl font-bold hover:bg-gray-300 transition-all"
                >
                  Back
                </button>
                <button
                  onClick={handleSubmit}
                  className="flex-1 bg-gradient-to-r from-orange-500 to-red-500 text-white py-3 rounded-2xl font-bold hover:shadow-lg transition-all duration-300 transform hover:scale-105 flex items-center justify-center gap-2"
                >
                  {isSubmitted ? 'Booking...' : 'Confirm Booking'}
                  <Check className="w-5 h-5" />
                </button>
              </div>
            </div>
          )}

          {/* Success Message */}
          {isSubmitted && (
            <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
              <div className="bg-white rounded-3xl shadow-2xl p-8 max-w-sm w-full text-center animate-bounce-in">
                <div className="w-20 h-20 mx-auto mb-4 bg-green-100 rounded-full flex items-center justify-center">
                  <Check className="w-12 h-12 text-green-500" />
                </div>
                <h3 className="text-2xl font-bold text-green-600 mb-2">Booking Confirmed!</h3>
                <p className="text-gray-600">
                  Table for <strong>{partySize}</strong> on <strong>{format(selectedDate, 'MMM dd')}</strong> at <strong>{selectedTime}</strong>
                </p>
                <p className="text-sm text-gray-500 mt-4">We'll send a confirmation to your phone.</p>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Custom Animation */}
      <style jsx>{`
        @keyframes bounce-in {
          0% { transform: scale(0.8); opacity: 0; }
          60% { transform: scale(1.05); }
          100% { transform: scale(1); opacity: 1; }
        }
        .animate-bounce-in {
          animation: bounce-in 0.5s ease-out;
        }
      `}</style>
    </section>
  );
};


const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitted(true);
    setTimeout(() => {
      setIsSubmitted(false);
      setFormData({ name: '', email: '', message: '' });
    }, 3000);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <div className="pt-24 min-h-screen bg-gradient-to-br from-orange-50 to-amber-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">

        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl sm:text-5xl font-extrabold bg-gradient-to-r from-orange-600 to-red-600 bg-clip-text text-transparent mb-4">
            Contact Us
          </h1>
          <p className="text-xl sm:text-2xl text-orange-800">Get in touch with us - we'd love to hear from you!</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">

          {/* Contact Info */}
          <div className="space-y-8">
            {/* Restaurant Info */}
            <div className="bg-white rounded-3xl shadow-2xl p-8 hover:shadow-3xl transition-shadow duration-500">
              <h2 className="text-2xl font-bold text-gray-800 mb-6">Visit Our Restaurant</h2>
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <MapPin className="w-6 h-6 text-orange-500 mt-1" />
                  <div>
                    <h3 className="font-semibold text-gray-800">Address</h3>
                    <p className="text-gray-600">
                      Shop 1, JN Road, Periyakuppam,<br />
                      Thiruvallur, Chennai - 602025
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <Phone className="w-6 h-6 text-orange-500 mt-1" />
                  <div>
                    <h3 className="font-semibold text-gray-800">Phone</h3>
                    <p className="text-gray-600">+91 93420 77664</p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <Clock className="w-6 h-6 text-orange-500 mt-1" />
                  <div>
                    <h3 className="font-semibold text-gray-800">Hours</h3>
                    <p className="text-gray-600">
                      Mon - Sun: 11:00 AM - 11:00 PM<br />
                      Open all days
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Location Map */}
            <div className="bg-white rounded-3xl shadow-2xl p-8 hover:shadow-3xl transition-shadow duration-500">
              <h2 className="text-2xl font-bold text-gray-800 mb-6">Our Location</h2>
              <div className="w-full aspect-[4/3] rounded-xl overflow-hidden shadow-inner">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3885.6630817988585!2d79.91020427484408!3d13.120517487208733!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a529125ea8120f3%3A0x7588c54bc8476484!2sOYEPAI!5e0!3m2!1sen!2sin!4v1761387557549!5m2!1sen!2sin"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="OyePai Location"
                  className="rounded-xl"
                ></iframe>
              </div>
            </div>

            {/* Call Now Card */}
            <div className="bg-gradient-to-br from-orange-500 to-red-500 rounded-3xl text-white p-8 shadow-xl hover:shadow-2xl transition-shadow duration-500">
              <h3 className="text-2xl font-bold mb-4">Ready to Order?</h3>
              <p className="mb-6">Call us now for quick delivery or dine-in reservations!</p>
              <a
                href="tel:+919342077664"
                className="bg-white text-orange-500 px-6 py-3 rounded-full font-bold hover:bg-orange-50 transition-colors inline-flex items-center space-x-2"
              >
                <Phone className="w-5 h-5" />
                <span>Call Now</span>
              </a>
            </div>
          </div>

          {/* Contact Form */}
          <div className="bg-white rounded-3xl shadow-2xl p-6 sm:p-8 hover:shadow-3xl transition-shadow duration-500">
            <h2 className="text-2xl font-bold text-gray-800 mb-6">Send us a Message</h2>

            {isSubmitted ? (
              <div className="text-center py-12">
                <Check className="w-16 h-16 text-green-500 mx-auto mb-4" />
                <h3 className="text-xl font-bold text-green-600 mb-2">Message Sent!</h3>
                <p className="text-gray-600">Thank you for reaching out. We'll get back to you soon.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2">
                    Your Name
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    value={formData.name}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none shadow-sm"
                    placeholder="Enter your name"
                  />
                </div>

                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                    Email Address
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none shadow-sm"
                    placeholder="Enter your email"
                  />
                </div>

                <div>
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                    Message
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    required
                    value={formData.message}
                    onChange={handleChange}
                    rows="5"
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-orange-500 focus:border-orange-500 outline-none shadow-sm"
                    placeholder="Tell us how we can help you..."
                  />
                </div>

                <button
                  type="submit"
                  className="w-full bg-gradient-to-r from-orange-500 to-red-500 text-white py-3 rounded-2xl font-bold hover:shadow-lg transition-all duration-300 transform hover:scale-105"
                >
                  Send Message
                </button>
              </form>
            )}
          </div>
        </div>

        {/* ========== FOLLOW US SECTION (ADDED) ========== */}
        <div className="mt-16 text-center">
          <h3 className="text-2xl md:text-3xl font-bold text-orange-900 mb-8">
            Follow Us
          </h3>

          <div className="flex justify-center items-center gap-6 md:gap-8">

            {/* Instagram */}
            <a
              href="https://www.instagram.com/oyepai?utm_source=qr&igsh=MTk0Y2o5cXowd3RtNQ=="
              target="_blank"
              rel="noopener noreferrer"
              className="group relative p-4 bg-white rounded-full shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 hover:scale-110"
              aria-label="Follow us on Instagram"
            >
              <div className="absolute inset-0 bg-gradient-to-br from-pink-400 to-orange-400 rounded-full blur-xl opacity-0 group-hover:opacity-60 transition-opacity duration-300"></div>
              <div className="relative w-10 h-10 md:w-12 md:h-12 bg-gradient-to-br from-pink-500 to-orange-500 text-white rounded-full flex items-center justify-center">
                <Instagram className="w-6 h-6 md:w-7 md:h-7" />
              </div>
            </a>

            {/* WhatsApp */}
            <a
              href="https://wa.me/919342077664"
              target="_blank"
              rel="noopener noreferrer"
              className="group relative p-4 bg-white rounded-full shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 hover:scale-110"
              aria-label="Chat with us on WhatsApp"
            >
              <div className="absolute inset-0 bg-gradient-to-br from-green-400 to-emerald-400 rounded-full blur-xl opacity-0 group-hover:opacity-60 transition-opacity duration-300"></div>
              <div className="relative w-10 h-10 md:w-12 md:h-12 bg-gradient-to-br from-green-500 to-emerald-600 text-white rounded-full flex items-center justify-center">
                <MessageCircle className="w-6 h-6 md:w-7 md:h-7" />
              </div>
            </a>

            {/* Google Maps */}
            <a
              href="https://www.google.com/maps/place/OYEPAI/@13.122304,79.912779,15z/data=!4m6!3m5!1s0x3a529125ea8120f3:0x7588c54bc8476484!8m2!3d13.1205175!4d79.9127792!16s%2Fg%2F11rc9rgr9l?hl=en&entry=ttu"
              target="_blank"
              rel="noopener noreferrer"
              className="group relative p-4 bg-white rounded-full shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 hover:scale-110"
              aria-label="Find us on Google Maps"
            >
              <div className="absolute inset-0 bg-gradient-to-br from-red-400 to-orange-400 rounded-full blur-xl opacity-0 group-hover:opacity-60 transition-opacity duration-300"></div>
              <div className="relative w-10 h-10 md:w-12 md:h-12 bg-gradient-to-br from-red-500 to-orange-600 text-white rounded-full flex items-center justify-center">
                <MapPin className="w-6 h-6 md:w-7 md:h-7" />
              </div>
            </a>

          </div>

          <p className="mt-6 text-sm text-orange-700">
            Stay connected for fresh updates, offers & food love!
          </p>
        </div>
        {/* ========== END FOLLOW US ========== */}

      </div>
    </div>
  );
};

// Footer Component
const Footer = ({ setCurrentView }) => {
  return (
    <footer className="bg-[#2e3e7b] text-white py-16">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Branding */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <div className="text-3xl font-extrabold bg-gradient-to-r from-orange-500 to-red-500 bg-clip-text text-transparent">
                OyePai
              </div>
              <Heart className="text-red-500 w-6 h-6 animate-pulse" />
            </div>
            <p className="text-gray-300 mb-4">
              Eat Love Repeat - Perfect place to hangout and chill 🥰
            </p>
            <div className="text-4xl space-x-2 animate-bounce">
              🍕🍔🍝🥪🥟🍗
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-orange-400">Quick Links</h3>
            <ul className="space-y-2 text-gray-300">
              {[
                { label: "Home", view: "home" },
                { label: "Menu", view: "menu" },
                { label: "About Us", view: "about" },
                { label: "Contact", view: "contact" }
              ].map(link => (
                <li key={link.view}>
                  <a
                    href="/"
                    onClick={(e) => {
                      e.preventDefault();
                      setCurrentView(link.view);
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                    className="hover:text-orange-400 transition-colors cursor-pointer font-medium"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-orange-400">Contact Info</h3>
            <div className="space-y-3 text-gray-300">
              <div className="flex items-center space-x-2">
                <MapPin className="w-5 h-5 text-orange-400" />
                <span className="text-sm">Shop 1, JN Road, Periyakuppam, Thiruvallur, Chennai</span>
              </div>
              <div className="flex items-center space-x-2">
                <Phone className="w-5 h-5 text-orange-400" />
                <span className="text-sm">+91 93420 77664</span>
              </div>
              <div className="flex items-center space-x-2">
                <Clock className="w-5 h-5 text-orange-400" />
                <span className="text-sm">Open: 11 AM - 11 PM (All Days)</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Note */}
        <div className="border-t border-orange-400 mt-12 pt-6">
          <div className="text-center text-sm font-medium text-gray-300">
            <p className="inline-flex items-center justify-center gap-1.5 w-full transition-colors hover:text-gray-100">
              &copy; 2025 Oyepai. Made with{' '}
              <span className="text-red-500 animate-pulse leading-none inline-block transition-transform hover:scale-110 hover:animate-none">
                ❤️
              </span>{' '}
              in Thiruvallur. All Rights Reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>

  )
}






export default App;